/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable multiline-comment-style */
/* eslint-disable react/display-name */
/* eslint-disable no-shadow */
/* eslint-disable max-lines */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-depth */
import React, { FC, forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import {
    useTable,
    useGlobalFilter,
    useAsyncDebounce,
    useSortBy,
    useFilters,
    useExpanded,
    usePagination,
    useRowSelect,
    useMountedLayoutEffect
} from 'react-table';
import {
    Table,
    Col,
    CardHeader,
    CardBody,
    Card,
    Button,
    Input,
    UncontrolledTooltip,
    Row,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody
} from 'reactstrap';
import { DefaultColumnFilter } from './tableFilters';
import { useNavigate } from 'react-router-dom';

import EllipsisToolTip from './Tooltip/Tooltip';
import Flatpickr from 'react-flatpickr';
import Select from 'react-select';
import { droneServiceActions, ellipsisToolTip, getDate, getDateOnly, IsAuthorized, IsAuthorizedCondition, transformDate } from './Util';
import { toast } from 'react-toastify';
import { TableSkelton } from './skeleton';
import Pagination from './Pagination';
import { regex } from './regex';
import SCCL from '../../assets/images/commons/scclLogo.svg';
import actionList from '../../assets/images/commons/actionList.svg';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import columnChooser from '../../assets/images/commons/columChooser.svg';
import details from '../../assets/images/commons/details.svg';
import editM from '../../assets/images/commons/editM.svg';
import deleteM from '../../assets/images/commons/deleteM.svg';
import view from '../../assets/images/commons/view.svg';

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }: any, ref: any) => {
    const defaultRef = useRef();
    const resolvedRef: any = ref || defaultRef;

    useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
        <>
            <input className="form-check-input" type="checkbox" ref={resolvedRef} {...rest} />
        </>
    );
});

interface TableContainerProps {
    columns?: any;
    data?: any;
    defaultLastDays?: number;
    defaultGetDate?: any;
    isGlobalSearch?: boolean;
    isGlobalFilter?: boolean;
    handleEdit?: any;
    handleAddNew?: () => void;
    handleClickView?: any;
    isAddCustList?: boolean;
    customPageSize?: number;
    tableClass?: string;
    theadClass?: string;
    trClass?: string;
    thClass?: string;
    divClass?: string;
    SearchPlaceholder?: string;
    totalRecords?: number;
    dateRangeFilter?: boolean;
    isAdmin?: boolean;
    datePlaceHolder?: string;
    loading?: boolean;
    onPageChange?: any;
    urlDates?: any;

    className?: string;
    editor?: string;
    deletor?: string;
    reader?: string;
    hideHeaderPadding?: boolean;
    searchFilter1?: boolean;
    searchPlaceholderSize?: number;
    largeSearchFilter?: boolean;
    addButton?: boolean;
    addButtonText?: string;
    columnChooser?: boolean;
    searchPlaceHolder?: string;
    multiTypeUpload?: boolean;
    multiTypeDownload?: true;
    pageNum?: number;
    handleMultiUpload?: any;
    handleMultiDownload?: any;
    onClickSwitch?: any;
    downloadBtn?: boolean;
    downloadBtnText?: string;
    handleDownloadAction?: any;
    tableHeader?: string;
    tableHeaderEnd?: string;
    searchVal?: string;
    dropDownValue?: any;
    SearchFilterWidth?: string;
    searchFilter2?: boolean;
    handlePriviligeView?: any;
    handleDelete?: any;
    handleGlobalSearch?: any;
    mode?: string;
    comment?: string;
    all?: boolean;
    write?: boolean;
    read?: boolean;
    hideDisplayTotalCount?: boolean;
    hideCheckBoxTooltip?: boolean;
    hidePagination?: boolean;
    handleCheckAll?: any;
    handleCheckboxChange?: any;
    handleSparePartClick?: any;
    handleFarmers?: any;
    handleRequestClick?: any;
    handleDroneClick?: any;
    emptyMessage?: string;
    showSelectAllOption?: boolean;
    onSelectedRowsChange?: any;
    props?: any;
    selectedRows?: any;
    handleClickViewDetails?: any;
    handleInfo?: any;
    handleCountViewPolicy?: any;
    handleView?: any;
    hideAvatar?: boolean;
    handleCreate?: any;
    mapIcon?: boolean;
    handleMapIcon?: any;
    handleCardIcon?: any;
    handleTableIcon?: any;
    tableIcon?: boolean;
    cardIcon?: boolean;
    isIcon?: string;
    currentTab?: number | string;
    columnChooserdata?: any;
    // additionalTableComponent?: any;
    onClickAttachments?: () => void;
}

const TableContainer: FC<TableContainerProps | any> = ({
    columns,
    data,
    isGlobalFilter,
    customPageSize,
    tableClass,
    theadClass,
    trClass,
    thClass,
    divClass,
    emptyMessage,
    tableHeader,
    tableHeaderEnd,
    onPageChange,
    totalRecords,
    pageNum,
    reader,
    editor,
    unAssignCondition,
    sparePartsCondition,
    farmerCondition,
    requestCondition,
    showSelectAllOption,
    onSelectedRowsChange,
    onClickAttachments,
    handleSparePartClick,
    handleFarmers,
    droneCondition,
    assignCondition,
    handleRequestClick,
    handleDroneClick,
    ...props
}) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        pageCount,
        previousPage,
        setPageSize,
        setGlobalFilter,
        state,
        globalFilteredRows,
        selectedFlatRows,
        state: { pageIndex, pageSize, selectedRowIds }
    } = useTable(
        {
            columns : columns ?? [],
            data : data ?? [],
            defaultColumn: { Filter: DefaultColumnFilter },
            initialState: {
                pageIndex: 0,
                pageSize: customPageSize ? customPageSize : 10,
                selectedRowIds: props.selectedRows ? props.selectedRows : {}
            }
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect,
        (hooks: { visibleColumns: ((cols: any) => any[])[] }) => {
            showSelectAllOption &&
                hooks.visibleColumns.push((cols: any) => [
                    // Let's make a column for selection
                    {
                        id: 'selection',
                        minWidth: 15,
                        maxWidth: 15,
                        width: 15,
                        /*
                         * The header can use the table's getToggleAllRowsSelectedProps method
                         * to render a checkbox
                         */
                        Header: ({ getToggleAllRowsSelectedProps }: any) => (
                            <div>
                                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} disabled={props.selectionCheckBoxDisabled} />
                            </div>
                        ),
                        /*
                         * The cell can use the individual row's getToggleRowSelectedProps method
                         * to the render a checkbox
                         */
                        Cell: ({ row }: any) => (
                            <div>
                                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} disabled={props.selectionCheckBoxDisabled} />
                            </div>
                        )
                    },
                    ...cols
                ]);
        }
    );

    const fp = useRef<any>(null);
    const history = useNavigate();
    const [activePage, setActivePage] = useState<number>(pageIndex + 1);
    const [fileUploader, setFileUploader] = useState<any>('');
    const [dateVal, setDateVal] = useState<any>(props?.selectedDates ? props?.selectedDates : '');
    const [value, setValue] = useState<string>(props.searchVal ? props.searchVal : props.handleGlobalSearch ? '' : state.globalFilter);
    const [dropDownValue, setDropDownValue] = useState<any>(props?.dropDownValue ? props?.dropDownValue : null);
    const [dropDownValue1, setDropDownValue1] = useState<any>(props?.dropDownValue1 ? props?.dropDownValue1 : null);
    const [dropDownValue2, setDropDownValue2] = useState<any>(props?.dropDownValue2 ? props?.dropDownValue2 : null);
    const [dropDownValue3, setDropDownValue3] = useState<any>(props?.dropDownValue3 ? props?.dropDownValue3 : null);
    const [dropDownValue4, setDropDownValue4] = useState<any>(props?.dropDownValue4 ? props?.dropDownValue4 : null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownOpen1, setDropdownOpen1] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState<any>([]);
    const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(null);

    const toggleDropdown = (index: number) => {
        setOpenDropdownIndex((prev) => (prev === index ? null : index));
    };
    const dropdownManuallyClosed = useRef(false);
    const toggle = () => {
        if (!dropdownOpen) {
            dropdownManuallyClosed.current = true;
        }
        setDropdownOpen((prevState) => !prevState);
    };
    const toggle1 = () => {
        setDropdownOpen1((prevState) => !prevState);
    };
    const columnChooserClick = (column: any) => {
        const columns = selectedColumns.map((col: any) => {
            if (col.key === column.key) {
                col.isActive = !col.isActive;
            }
            return col;
        });
        setSelectedColumns(columns);
    };

    // const navigate = useNavigate();
    useEffect(() => {
        setValue(props.searchVal);
    }, [props.searchVal]);

    useEffect(() => {
        if (props?.clearSearchValue) props?.clearSearchValue(setValue);
    }, [props?.currentTab]);

    useEffect(() => {
        setDropDownValue(props?.dropDownValue);
    }, [props?.dropDownValue]);

    useEffect(() => {
        const safeData = props?.columnChooserdata ?? [];
        const data = JSON.parse(JSON.stringify(safeData));
        setSelectedColumns(data);
    }, [props?.columnChooserdata]);

    useEffect(() => {
        if (!dropDownValue) {
            if (dropdownManuallyClosed.current) {
                dropdownManuallyClosed.current = false;
            } else {
                const safeData = props?.columnChooserdata ?? [];
                const data = JSON.parse(JSON.stringify(safeData));
                setSelectedColumns(data);
            }
        } else {
        }
    }, [dropdownOpen]);
    const clicked = () => {};
    // useEffect(() => {
    //     // const today = new Date();
    //     // const startDate = new Date(today);
    //     // startDate.setDate(today.getDate() - (props.defaultLastDays - 1));
    //     // startDate.setUTCHours(0, 0, 0, 0); // Set the time to the start of the day in UTC
    //     // today.setUTCHours(23, 59, 59, 999);

    //     if (props?.isUrlDateRange) {
    //         setDateVal([new Date(props?.urlDates[0]), new Date(props?.urlDates[1])]);
    //     } else {
    //         const today = new Date();
    //         const defaultDays = new Date(today.getTime() - props.defaultLastDays * 24 * 60 * 60 * 1000); // 6 days ago, so including today makes 7 days

    //         if (props.defaultGetDate && props.defaultLastDays) setDateVal([defaultDays, today]);
    //         if (props.defaultGetDate && !props?.isUrlDateRange) props?.defaultGetDate([defaultDays, today]);
    //     }
    // }, []);

    useEffect(() => {
        if (props?.urlDates?.[0] && props?.urlDates?.[1]) {
            const startDate = new Date(props?.urlDates?.[0]);
            let endDate = new Date(props?.urlDates?.[1]);

            startDate.setUTCHours(0, 0, 0, 0);

            const today = new Date();
            if (endDate > today) {
                endDate = today;
            } else {
                endDate.setUTCHours(23, 59, 59, 999);
            }

            setDateVal([startDate, endDate]);
            props?.defaultGetDate([startDate, endDate]);
        } else {
            const today = new Date();
            const defaultDays = new Date(today.getTime() - props?.defaultLastDays * 24 * 60 * 60 * 1000);

            if (props.defaultGetDate && props.defaultLastDays) setDateVal([defaultDays, today]);
            if (props?.defaultGetDate && props?.defaultLastDays) props?.defaultGetDate([defaultDays, today]);
        }
    }, []);

    useMountedLayoutEffect(() => {
        onSelectedRowsChange && onSelectedRowsChange(selectedRowIds, selectedFlatRows);
    }, [onSelectedRowsChange, selectedRowIds]);

    const generateSortingIndicator = (column: { isSorted: any; isSortedDesc: any }) => {
        return column.isSorted ? (
            column.isSortedDesc ? (
                <img className="sortsymbol" src={SCCL} alt="desc" />
            ) : (
                <img className="sortsymbol" src={SCCL} alt="asc" />
            )
        ) : (
            ''
        );
    };

    const onClickAction = (
        cell: { column: { view: any; viewRoute: string; routeKey: any } },
        row: { original: { [x: string]: string } },
        action: string
    ) => {
        switch (action) {
            case 'view':
                if (cell.column.view) {
                    if (cell.column.viewRoute) {
                        history(`${cell.column.viewRoute + '/' + row.original[cell.column.routeKey ? cell.column.routeKey : '_id']}`);
                    } else props.handleClickView(row, cell);
                } else {
                    props.handleClickView(row, cell);
                }
                break;
            case 'view1':
                props.handleClickView1(row);
                break;
            case 'viewDetails':
                props.handleClickViewDetails(row, cell);
                break;
            case 'info':
                props.handleInfo(row, cell);
                break;
            default:
                break;
        }
    };

    const Tooltip = (id: any, label: any, placement?: any) => {
        return (
            <UncontrolledTooltip placement={placement ? placement : 'bottom'} target={id}>
                {label}
            </UncontrolledTooltip>
        );
    };

    const copyToClipboard = async (e: React.MouseEvent<HTMLElement, MouseEvent>, val: string, id: string, toastMsg: any) => {
        navigator.clipboard.writeText(val).then(() => {
            toast.success(toastMsg);
        });
    };

    const label = (names: string) => {
        const nameArr = names?.split(' ');
        const returnVal =
            nameArr?.length > 1
                ? nameArr?.[0]?.charAt(0)?.toUpperCase() + nameArr?.[1]?.charAt(0)?.toUpperCase()
                : names?.substring(0, 2)?.toUpperCase();
        return returnVal;
    };

    const prepareCustomBody = (
        cell:
            | {
                  column: {
                      fieldType: any;
                      key: string | number;
                      dateOnly: any;
                      value: string | number;
                      hideLink: any;
                      iconField: string | number;
                      id: string | number;
                      startField: string | number;
                      endField: string | number;
                      accessor3: string | number;
                      accessor2: string | number;
                      accessor1: string | number;
                      imageURL: string | number;
                      icon: any;
                      icon2: any;
                      fieldKey: string | number;
                      copyToastMsg: any;
                      type: any;
                      copy: any;
                      dataKey: string | number;
                      tooltip: any;
                      tooltipKey: string | number;
                      textColorClass: any;
                      badgeClass: any;
                      tooltipAccessor: string | number;
                      className: any;
                      onHideAction: string | number;
                      onHideClass: string | number;
                      hideActions: any;
                      actionsHideKey: string | number;
                      rowAdd: any;
                      clearData: any;
                      clearCache: any;
                      rowEdit: any;
                      view: any;
                      devicemove: any;
                      notes: any;
                      reboot: any;
                      lock: any;
                      map: any;
                      resetpassword: any;
                      scream: any;
                      lostMode: any;
                      factoryreset: any;
                      edit: any;
                      editFadable: any;
                      fadeEdit: string | number;
                      fadeTooltipKeyEdit: string | number;
                      fadeTooltip: any;
                      qrCode: any;
                      clone: any;
                      clone1: any;
                      urlDownload: any;
                      rename: any;
                      move: any;
                      moveTooltip: any;
                      treeView: any;
                      deleteOnCount: any;
                      config: any;
                      configFade: string | number;
                      configTooltip: any;
                      refresh: any;
                      noUpdate: string | number;
                      deleteFadable: any;
                      fade: string | number;
                      fadeTooltipKeyDelete: string | number;
                      delete: any;
                      unAssign: any;
                      rowDelete: any;
                      download: any;
                      downloadTooltip: any;
                      shareWithText: any;
                      text:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | Iterable<React.ReactNode>
                          | null
                          | undefined;
                      hideTakeAction: string | number;
                      takeActionClass: string | undefined;
                      hideTooltip: any;
                      onlineStatusTooltip: string | number;
                      disable: string | number;
                      checkedAccessor: string | number;
                      key3: string | number;
                      key2: string | number;
                      key1: string | number;
                      keyVal: any;
                      textClass: any;
                      showTooltipKey: string | number;
                      infoTooltip: string | number;
                      circleClass: string | number;
                      screenshot: any;
                      volume: any;
                      deprovision: any;
                      wipeUser: any;
                  };
                  render: (
                      arg0: string
                  ) =>
                      | string
                      | number
                      | boolean
                      | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                      | Iterable<React.ReactNode>
                      | null
                      | undefined;
              }
            | any,
        row:
            | {
                  index: number;
                  original: {
                      [x: string]:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | Iterable<React.ReactNode>
                          | null
                          | undefined;
                      noLink: any;
                      status: string;
                      hideView: any;
                      avatarColor: any;
                      icon: string | undefined;
                      iconClass: any;
                      iconTooltip: any;
                      icon2: any;
                      iconClass2: any;
                      icon2Tooltip: any;
                      rowView: any;
                      img: string | undefined;
                      name: string;
                      iconBadgeClass: string;
                      textColorClass: any;
                      badgeClass: any;
                      showTooltip: any;
                      disabled: boolean | undefined;
                      progressBadgeClass: any;
                      violations?: { geofence: string } | any;
                      hideActions: any;
                      actionsBadge: any;
                      actionsBadgeTitle:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | Iterable<React.ReactNode>
                          | null
                          | undefined;
                      rowAdd: any;
                      rowEdit: any;
                      showActions: any;
                      disableReboot: any;
                      disableLock: any;
                      hideMapView: any;
                      disableResetPassword: any;
                      disableScream: any;
                      hideLostMode: any;
                      hideFactoryReset: any;
                      hideQR: any;
                      hideRename: any;
                      hideMove: any;
                      delete: any;
                      unAssign: any;
                      hideDelete: any;
                      rowDelete: any;
                      takeActionText:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | Iterable<React.ReactNode>
                          | null
                          | undefined;
                      onlineStatusClass: any;
                      checked: boolean | undefined;
                      hideRadio: any;
                      hideScreenshot: any;
                      hidedeoprovision: any;
                      hideWipeUser: any;
                  };
              }
            | any,
        index: any
    ) => {
        let body = undefined;
        switch (cell?.column?.fieldType) {
            case 'Sl-No':
                body = <div className="d-flex">{row?.index + 1}</div>;
                break;
            case 'dateFormat':
                body = (
                    <div className="d-flex">
                        {row.original[cell.column.id] !== '—'
                            ? cell.column.dateOnly
                                ? getDateOnly(row.original[cell.column.id])
                                : getDate(row.original[cell.column.id])
                            : '—'}
                    </div>
                );
                break;
            case 'clickable':
                body = cell.column.key ? (
                    row.original[cell.column.key] === cell.column.value ? (
                        <span className="fw-medium link-primary cursor-pointer" onClick={() => onClickAction(cell, row, 'view')}>
                            <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                        </span>
                    ) : (
                        <span>
                            <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                        </span>
                    )
                ) : cell.column.condition === false || row?.original?.clickableCondition === false ? (
                    // B: condition is explicitly false

                    <div className={'text-black'}>
                        <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                    </div>
                ) : (
                    // A: condition is true or not present (undefined)
                    <span
                        className={`fw-medium ${
                            row.original[cell.column.disableClick] ? 'cursor-none text-muted' : 'cursor-pointer link-primary'
                        }`}
                        onClick={() => (row.original[cell.column.disableClick] ? '' : onClickAction(cell, row, 'view'))}
                    >
                        <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                    </span>
                );
                break;
            case 'clickableArray':
                body =
                    row?.original?.['usersCount'] > 0 ? (
                        <>
                            <span
                                className={`fw-medium ${
                                    row?.original?.[cell?.column?.disableClick] ? 'cursor-none text-muted' : 'cursor-pointer link-primary'
                                }`}
                                onClick={() => onClickAction(cell, row, 'view')}
                            >
                                <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>
                                    {row?.original?.['usersCount']}
                                </EllipsisToolTip>
                            </span>
                        </>
                    ) : (
                        <>
                            <span>{row?.original?.['usersCount']}</span>
                        </>
                    );
                break;
            case 'clickable1':
                body = cell.column.key ? (
                    row.original[cell.column.key] === cell.column.value ? (
                        <span className="fw-medium link-primary cursor-pointer" onClick={() => onClickAction(cell, row, 'view1')}>
                            <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                        </span>
                    ) : (
                        <span>
                            <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                        </span>
                    )
                ) : (
                    <span className="fw-bold link-primary cursor-pointer" onClick={() => onClickAction(cell, row, 'view1')}>
                        <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                    </span>
                );

                break;

            case 'droneClickable':
                body = (
                    <div className="d-flex gap-2 justify-content-start align-items-center">
                        <span className="mb-1">
                            <img
                                src={cell?.row?.original?.online ? SCCL : SCCL}
                                alt={cell?.row?.original?.online ? 'online-dot' : 'offline-dot'}
                            />
                        </span>
                        <span
                            className={`fw-medium ${
                                row.original[cell.column.disableClick] ? 'cursor-none text-muted' : 'cursor-pointer link-primary'
                            }`}
                            onClick={() => !row.original[cell.column.disableClick] && onClickAction(cell, row, 'view')}
                        >
                            <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                        </span>
                    </div>
                );

                break;
            case 'conditionalClickable':
                body = row.original.noLink ? (
                    <span>{cell.render('Cell')}</span>
                ) : (
                    <span
                        className={`fw-medium ${cell.column.hideLink ? '' : 'link-primary cursor-pointer'}`}
                        onClick={() => onClickAction(cell, row, 'view')}
                    >
                        {row.original[cell.column.iconField] && (
                            <sup className="me-1 text-danger fw-bold fs-17" id={`policyChange-${index}-${cell.column.id}`}>
                                <i className="ri-checkbox-blank-circle-fill link-danger font-size-8" />
                            </sup>
                        )}
                        {row.original[cell.column.iconField] &&
                            Tooltip(
                                `policyChange-${index}-${cell.column.id}`,
                                `Policy updating from ${row.original[cell.column.startField]} to ${row.original[cell.column.endField]}`
                            )}
                        {cell.render('Cell')}
                    </span>
                );
                break;
            case 'tickandcross':
                body = (
                    <div>
                        <i
                            className={`${
                                row.original.status === 'published' ? 'ri-check-fill link-success' : 'ri-subtract-line text-muted'
                            } fw-bold fs-18`}
                        />
                    </div>
                );
                break;
            case 'deviceCount':
                body = (
                    <Row className="d-flex align-items-center">
                        {/* <Col sm={3} className="d-flex align-items-center text-truncate">
                            <span className="text-muted me-1">({row.original[cell.column.accessor1]})</span>
                        </Col> */}
                        <Col sm={'3'} className="d-flex align-items-center text-truncate">
                            <span className="d-flex align-items-center" id={`key3-${index}`}>
                                <i className="ri-checkbox-blank-circle-fill link-success me-1" />
                                {row.original[cell.column.accessor3]}
                            </span>
                            {Tooltip(`key3-${index}`, 'Latest: ' + row.original?.[cell.column.accessor3])}
                        </Col>
                        <Col sm={'3'} className="d-flex align-items-center text-truncate" id={`key2-${index}`}>
                            <span className="d-flex align-items-center">
                                <i className="ri-checkbox-blank-circle-fill link-warning me-1" />
                                {row.original[cell.column.accessor2]}
                            </span>
                            {Tooltip(`key2-${index}`, 'Not Latest: ' + row.original?.[cell.column.accessor2])}
                        </Col>
                        <Col sm={'3'} className="d-flex align-items-center text-truncate" id={`key1-${index}`}>
                            <span className="d-flex align-items-center">
                                <i className="ri-checkbox-blank-circle-fill link-danger me-1" />
                                {row.original[cell.column.accessor1]}
                            </span>
                            {Tooltip(`key1-${index}`, 'Not Installed: ' + row.original?.[cell.column.accessor1])}
                        </Col>
                    </Row>
                );
                break;
            case 'countWithText':
                body = (
                    <div className="d-flex align-items-center">
                        <span className="text-primary me-1 fw-semibold text-decoration-underline">
                            {row.original[cell.column.accessor1] > 0
                                ? row.original[cell.column.accessor1].toLocaleString('en-US', {
                                      minimumIntegerDigits: 2,
                                      useGrouping: false
                                  })
                                : row.original[cell.column.accessor1]}
                        </span>
                        {row.original[cell.column.accessor1] > 0 ? (
                            <span className="text-muted fw-medium">({row.original[cell.column.accessor2] + ' Devices'})</span>
                        ) : (
                            ''
                        )}
                    </div>
                );
                break;
            case 'avatarText':
                body = (
                    <div>
                        {row.original.hideView ? (
                            <div className="d-flex align-items-center w-fit fw-medium">
                                <span
                                    style={{ backgroundColor: row.original.avatarColor }}
                                    className="width-30 height-30 me-1 rounded-circle header-profile-user d-flex align-items-center justify-content-center fs-10 text-white"
                                >
                                    {label(row.original[cell.column.value])}
                                </span>
                                {cell.render('Cell')}
                            </div>
                        ) : (
                            <div
                                className="d-flex align-items-center w-fit link-secondary text-secondary fw-medium cursor-pointer"
                                onClick={() => props.handleView(cell, row)}
                            >
                                {!props.hideAvatar && (
                                    <span
                                        style={{ backgroundColor: row.original.avatarColor }}
                                        className="width-30 height-30 me-1 rounded-circle header-profile-user d-flex align-items-center justify-content-center fs-10 text-white"
                                    >
                                        {label(row.original[cell.column.value])}
                                    </span>
                                )}
                                {cell.render('Cell')}
                            </div>
                        )}
                    </div>
                );
                break;
            case 'iconText':
                body = (
                    <div>
                        <div className="d-flex align-items-center">
                            <img className="me-1 rounded" src={row.original[cell.column.imageURL]} alt="app" width={20} height={20} />
                            <span
                                className={`text-truncate fw-medium ${
                                    row.original[cell.column.accessor2] > 0 ? ' cursor-pointer text-secondary fw-semibold' : ''
                                }`}
                                onClick={() => {
                                    if (row.original[cell.column.accessor2] > 0) props.handleCountViewPolicy(row, index, cell);
                                }}
                                id={`iconText-${index}`}
                            >
                                {cell.render('Cell')}
                            </span>
                            {Tooltip(`iconText-${index}`, cell.render('Cell'))}
                        </div>
                    </div>
                );
                break;
            case 'iconClickable':
                body = (
                    <div
                        className="m-1 d-flex align-items-center cursor-pointer link-primary fw-medium"
                        onClick={() => onClickAction(cell, row, 'viewDetails')}
                    >
                        {row.original.icon && (
                            <>
                                <i
                                    className={`${row.original.icon ? row.original.icon : cell.column.icon} fs-18 ${
                                        row.original.iconClass ? row.original.iconClass : 'link-secondary'
                                    } me-1`}
                                    id={`icon1-${index}`}
                                />
                                {row.original.iconTooltip && Tooltip(`icon1-${index}`, row.original.iconTooltip)}
                            </>
                        )}
                        {row.original.icon2 && (
                            <>
                                <i
                                    className={`${row.original.icon2 ? row.original.icon2 : cell.column.icon2} fs-18 ${
                                        row.original.iconClass2 ? row.original.iconClass2 : 'link-secondary'
                                    } me-1`}
                                    id={`icon2-${index}`}
                                />
                                {row.original.icon2Tooltip && Tooltip(`icon2-${index}`, row.original.icon2Tooltip)}
                            </>
                        )}
                        <span className="text-secondary">{cell.render('Cell')}</span>
                    </div>
                );
                break;
            case 'info':
                body = (
                    <div className="d-flex align-items-center fw-medium">
                        <i
                            className={`${cell.column.icon} me-1 link-info cursor-pointer`}
                            onClick={() => onClickAction(cell, row, 'info')}
                        />
                        <span>{cell.render('Cell')}</span>
                    </div>
                );
                break;
            case 'copy':
                body = (
                    <>
                        <div className="d-flex align-items-center">
                            <span className="fw-medium text-truncate">{ellipsisToolTip(cell.render('Cell'))}</span>
                            {row.original[cell.column.fieldKey] !== '—' && (
                                <span className="me-2">
                                    <i
                                        id={`${cell.column.fieldKey}-copy-${index}`}
                                        onClick={(e: any) =>
                                            copyToClipboard(
                                                e,
                                                row.original[cell.column.fieldKey],
                                                `${cell.column.fieldKey}-copy-${index}`,
                                                cell.column.copyToastMsg
                                            )
                                        }
                                        className="ri-file-copy-line ms-2 fs-13 cursor-pointer link-primary"
                                    ></i>
                                    {Tooltip(`${cell.column.fieldKey}-copy-${index}`, 'Copy')}
                                </span>
                            )}
                        </div>
                    </>
                );
                break;
            case 'fieldClickable':
                body = (
                    <>
                        {row.original.rowView ? (
                            <div className="d-flex align-items-center">
                                <span
                                    className="fw-medium link-secondary cursor-pointer text-truncate"
                                    onClick={() => onClickAction(cell, row, cell.column.type ? cell.column.type : 'view')}
                                >
                                    {ellipsisToolTip(cell.render('Cell'))}
                                </span>
                                {cell.column.copy && (
                                    <span className="me-2">
                                        <i
                                            id={`${cell.column.fieldKey}-copy-${index}`}
                                            onClick={(e: any) =>
                                                copyToClipboard(
                                                    e,
                                                    row.original[cell.column.fieldKey],
                                                    `${cell.column.fieldKey}-copy-${index}`,
                                                    cell.column.copyToastMsg
                                                )
                                            }
                                            className="ri-file-copy-line ms-2 fs-13 cursor-pointer link-primary"
                                        ></i>
                                        {Tooltip(`${cell.column.fieldKey}-copy-${index}`, 'Copy')}
                                    </span>
                                )}
                            </div>
                        ) : (
                            <span>
                                {cell.render('Cell')}
                                {cell.column.copy && (
                                    <span className="me-2">
                                        <i
                                            id={`${cell.column.fieldKey}-copy-${index}`}
                                            onClick={(e: any) =>
                                                copyToClipboard(
                                                    e,
                                                    row.original[cell.column.fieldKey],
                                                    `${cell.column.fieldKey}-copy-${index}`,
                                                    cell.column.copyToastMsg
                                                )
                                            }
                                            className="ri-file-copy-line ms-2 fs-13 cursor-pointer link-primary"
                                        ></i>
                                        {Tooltip(`${cell.column.fieldKey}-copy-${index}`, 'Copy')}
                                    </span>
                                )}
                            </span>
                        )}
                    </>
                );
                break;
            case 'imageLabel':
                body = (
                    <>
                        <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                                {row.original.img ? (
                                    <img src={row.original.img} alt="" className="avatar-xxs rounded-circle" />
                                ) : (
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">
                                            {row.original.name.charAt(0)}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex-grow-1 ms-2 name">{cell.render('Cell')}</div>
                        </div>
                    </>
                );
                break;
            case 'iconLabel':
                body =
                    row?.original?.[cell.column.dataKey] !== '—' ? (
                        <div className="d-flex align-items-center">
                            <img src={row.original.icon} alt="" className="me-1" />
                            <div className={'flex-grow-1 name text-' + row?.original?.iconBadgeClass}>
                                <span id={`battery-${index}`} className="w-fit">
                                    {cell.render('Cell')}
                                </span>
                                {cell.column.tooltip && Tooltip(`battery-${index}`, row.original?.[cell.column.tooltipKey])}
                            </div>
                        </div>
                    ) : (
                        <span>{cell.render('Cell')}</span>
                    );
                break;
            case 'textColor':
                body = (
                    <span
                        className={
                            'text-' +
                            (cell?.column?.textColorClass || row?.original?.textColorClass || row.original[cell?.column?.colorClass])
                        }
                    >
                        {/* {cell.render('Cell')} */}
                        {cell.value ? cell.render('Cell') : '-'}
                    </span>
                );
                break;
            case 'badge':
                body = (
                    <div className="d-flex align-items-center gap-2">
                        <span className={'lh-sm badge badge-soft-' + (cell?.column?.badgeClass || row?.original?.badgeClass)}>
                            {cell.render('Cell')}
                        </span>
                        {row.original.showTooltip && (
                            <>
                                <i className="ri-information-line cursor-pointer" id={`info-${index}`} />
                                {Tooltip(`info-${index}`, row?.original?.[cell.column?.tooltipAccessor])}
                            </>
                        )}
                    </div>
                );
                break;
            case 'customBadge':
                body = (
                    <span className={'m-1 lh-sm badge badge-soft-' + (cell?.column?.badgeClass || row?.original?.badgeClass)}>
                        {cell.render('Cell')}
                    </span>
                );
                break;
            case 'coloredText':
                body = <span className={'text-' + (cell?.column?.badgeClass || row?.original?.badgeClass)}>{cell.render('Cell')}</span>;
                break;

            case 'Id':
                body = <span>{row.original.pairId ? row.original.pairId : row.original.assetId}</span>;
                break;
            case 'attachments':
                body = (
                    // <span>
                    //     {row?.original?.[cell.column?.id] ? (
                    //         <span className="cursor-pointer" onClick={() => onClickAttachments(row, cell, index)}>
                    //             <img src={imagesIcon} alt="attachment" width={20} height={20} />
                    //             <span className="text-primary ms-2">{`Attachments (${row?.original?.[cell.column?.id]?.length})`}</span>
                    //         </span>
                    //     ) : (
                    //         '-'
                    //     )}
                    // </span>
                    <span>
                        {row?.original?.[cell.column?.id]?.length > 0 ? (
                            <span className="cursor-pointer" onClick={() => onClickAttachments(row, cell, index)}>
                                <img src={SCCL} alt="attachment" width={20} height={20} />
                                {/* <span className="text-primary ms-2">{`Attachments (${row?.original?.[cell.column?.id]?.length})`}</span> */}
                                <span className="text-primary ms-2 mt-2">
                                    {`Attachments (${
                                        Array.isArray(row?.original?.[cell.column?.id])
                                            ? row.original[cell.column.id].length
                                            : row?.original?.[cell.column?.id]
                                            ? 1
                                            : 0
                                    })`}
                                </span>
                            </span>
                        ) : (
                            '-'
                        )}
                    </span>
                );
                break;
            case 'switch':
                body = (
                    <IsAuthorized
                        privRequired={props?.priv?.switch}
                        yes={() => (
                            <span>
                                <div className="form-switch form-switch-sm">
                                    <Input
                                        className={`form-check-input cursor-pointer ${cell.column.className ? cell.column.className : ''}`}
                                        type="checkbox"
                                        role="switch"
                                        name={'status'}
                                        id={`switch-${index}`}
                                        disabled={row.original.disabled}
                                        onChange={(e: any) => props.onClickSwitch(row, cell, index)}
                                        checked={row.original?.[cell.column.fieldKey]}
                                        // checked={row?.original?.acitve}
                                    />
                                    {Tooltip(`switch-${index}`, row.original?.[cell.column.fieldKey] ? 'Active' : 'Inactive')}
                                </div>
                            </span>
                        )}
                    />
                );
                break;
            case 'progress':
                body = (
                    <div className="d-flex align-items-center">
                        <div className="flex-shrink-0 me-1 text-muted fs-13">
                            {cell.render('Cell')}
                            {cell.column.showPercent ? ' %' : ''}
                        </div>
                        <div className="progress progress-sm  flex-grow-1">
                            <div
                                role="progressbar"
                                aria-valuemin={0}
                                aria-valuenow={53}
                                aria-valuemax={100}
                                className={`progress-bar bg-${row.original.progressBadgeClass} rounded`}
                                style={{ width: `${row.original[cell.column.fieldKey]}%` }}
                            ></div>
                        </div>
                    </div>
                );
                break;
            case 'violations':
                body = (
                    <div className="d-flex align-items-center">
                        {/* <i
                            id={`sim-${index}`}
                            className={`ri-sim-card-2-line me-1 fs-15 ${
                                row.original.violations.sim?.toLowerCase() === 'y'
                                    ? 'link-danger'
                                    : row.original.violations.sim?.toLowerCase() === 'n'
                                    ? 'link-green-1'
                                    : 'link-primary'
                            }`}
                        />
                        {Tooltip(
                            `sim-${index}`,
                            row.original.violations.sim
                                ? 'SIM: ' + (row.original.violations.sim?.toLowerCase() === 'y' ? 'In Violation' : 'No Violation')
                                : 'SIM: No data available'
                        )} */}
                        {/*   <i
                            id={`memory-${index}`}
                            className={`ri-sd-card-mini-line me-1 fs-15 ${
                                row.original.violations.memory?.toLowerCase() === 'y'
                                    ? 'link-danger'
                                    : row.original.violations.memory?.toLowerCase() === 'n'
                                    ? 'link-green-1'
                                    : 'link-primary'
                            }`}
                        />
                        {Tooltip(
                            `memory-${index}`,
                            row.original.violations.memory
                                ? 'SD Card: ' + (row.original.violations.memory?.toLowerCase() === 'y' ? 'In Violation' : 'No Violation')
                                : 'SD Card: No data available'
                        )}
                         <i
                            id={`message-${index}`}
                            className={`ri-message-2-line me-1 fs-15 ${
                                row.original.violations.message?.toLowerCase() === 'y'
                                    ? 'link-danger'
                                    : row.original.violations.message?.toLowerCase() === 'n'
                                    ? 'link-green-1'
                                    : 'link-primary'
                            }`}
                        />
                        {Tooltip(
                            `message-${index}`,
                            row.original.violations.message
                                ? 'Message: ' + (row.original.violations.message?.toLowerCase() === 'y' ? 'In Violation' : 'No Violation')
                                : 'Message: No data available'
                        )}
                         <i
                            id={`wifi-${index}`}
                            className={`ri-wifi-line me-1 fs-15 ${
                                row.original.violations.wifi?.toLowerCase() === 'y'
                                    ? 'link-danger'
                                    : row.original.violations.wifi?.toLowerCase() === 'n'
                                    ? 'link-green-1'
                                    : 'link-primary'
                            }`}
                        />
                        {Tooltip(
                            `wifi-${index}`,
                            row.original.violations.wifi
                                ? 'Wi-fi: ' + (row.original.violations.wifi?.toLowerCase() === 'y' ? 'In Violation' : 'No Violation')
                                : 'Wi-fi: No data available'
                        )} */}
                        <i
                            id={`geofence-${index}`}
                            className={`ri-map-pin-line me-1 fs-15 ${
                                row.original.violations.geofence?.toLowerCase() === 'y'
                                    ? 'link-danger'
                                    : row.original.violations.geofence?.toLowerCase() === 'n'
                                    ? 'link-green-1'
                                    : 'link-primary'
                            }`}
                        />
                        {Tooltip(
                            `geofence-${index}`,
                            row.original.violations.geofence
                                ? 'Geo-fence: ' +
                                      (row.original.violations.geofence?.toLowerCase() === 'y' ? 'In Violation' : 'No Violation')
                                : 'Geo-fence: No data available'
                        )}
                        {/* <i
                            id={`unauthorized-${index}`}
                            className={`ri-apps-line me-1 fs-15 ${
                                row.original.violations.unauth?.toLowerCase() === 'y'
                                    ? 'link-danger'
                                    : row.original.violations.unauth?.toLowerCase() === 'n'
                                    ? 'link-green-1'
                                    : 'link-primary'
                            }`}
                        />
                        {Tooltip(
                            `unauthorized-${index}`,
                            row.original.violations.unauth
                                ? 'Apps: ' + (row.original.violations.unauth?.toLowerCase() === 'y' ? 'In Violation' : 'No Violation')
                                : 'Apps: No data available'
                        )} */}
                    </div>
                );
                break;
            case 'droneServices':
                body = droneServiceActions(cell.row, cell.column, cell.index, props);
                break;
            case 'actions':
                body = row.original.hideActions ? (
                    <>
                        {cell.column.onHideAction ? (
                            <span className={`lh-sm badge badge-soft-${row.original[cell.column.onHideClass]}`}>
                                {row.original[cell.column.onHideAction]}
                            </span>
                        ) : (
                            '—'
                        )}
                    </>
                ) : (
                    <>
                        {row.original.actionsBadge ? (
                            <span className={'lh-sm badge badge-soft-primary'}>{row.original.actionsBadgeTitle}</span>
                        ) : (
                            (cell.column.hideActions ? !row.original[cell.column.actionsHideKey] : true) && (
                                <div className="d-flex align-items-center">
                                    {row.original.rowAdd && cell?.column?.rowAdd && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`add-${index}`}
                                                        className="ri-add-box-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleCreate(row, cell, index)}
                                                    />
                                                    {Tooltip(`add-${index}`, 'Add')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.clearData && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`clearData-${index}`}
                                                        className="ri-line-chart-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleClearData(row)}
                                                    />
                                                    {Tooltip(`clearData-${index}`, 'Clear Data')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell.column.clearCache && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <span className="link-primary me-1 fs-15 ">
                                                        <i
                                                            id={`clearCache-${index}`}
                                                            className="ri-eraser-fill me-2 fs-18 cursor-pointer link-secondary"
                                                            onClick={() => props.handleClearCache(row)}
                                                        />
                                                        {Tooltip(`clearCache-${index}`, 'Clear Cache')}
                                                    </span>
                                                </>
                                            )}
                                        />
                                    )}
                                    {row.original.rowEdit &&
                                        cell?.column?.rowEdit &&
                                        (props.groupAccess ? (
                                            <IsAuthorizedCondition
                                                key={props.accessingKey}
                                                value={props.accessingValue}
                                                yes={() => (
                                                    <>
                                                        <i
                                                            title="Edit"
                                                            id={`edit-${index}`}
                                                            className="ri-edit-box-line me-2 fs-18 cursor-pointer link-secondary"
                                                            onClick={() => props.handleEdit(row, cell, index)}
                                                        />
                                                        {Tooltip(`edit-${index}`, 'Edit')}
                                                    </>
                                                )}
                                            />
                                        ) : (
                                            <IsAuthorized
                                                privRequired={editor}
                                                yes={() => (
                                                    <>
                                                        <i
                                                            id={`edit-${index}`}
                                                            className="ri-edit-box-line me-2 fs-18 cursor-pointer link-secondary"
                                                            onClick={() => props.handleEdit(row, cell, index)}
                                                        />
                                                        {Tooltip(`edit-${index}`, 'Edit')}
                                                    </>
                                                )}
                                            />
                                        ))}
                                    {cell?.column?.view && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`view-${index}`}
                                                        className="ri-eye-line me-2 fs-18 cursor-pointer link-success"
                                                        onClick={() => props.handleView(row, cell, index)}
                                                    />
                                                    {Tooltip(`view-${index}`, 'View')}
                                                </>
                                            )}
                                        />
                                    )}{' '}
                                    {cell?.column?.devicemove && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`devicemove-${index}`}
                                                        className="ri-folder-transfer-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleMove(row, cell, index)}
                                                    />
                                                    {Tooltip(`devicemove-${index}`, 'Move')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.notes && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`notes-${index}`}
                                                        className="ri-draft-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleNotes(row, cell, index)}
                                                    />
                                                    {Tooltip(`notes-${index}`, 'Notes')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.reboot && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`reboot-${index}`}
                                                        className={`ri-creative-commons-sa-line me-2 fs-18 ${
                                                            row.original.showActions && !row.original.disableReboot
                                                                ? 'cursor-pointer link-secondary'
                                                                : 'text-muted'
                                                        }`}
                                                        onClick={() =>
                                                            row.original.showActions && !row.original.disableReboot
                                                                ? props.handleDeviceReboot(row, cell, index)
                                                                : undefined
                                                        }
                                                    />
                                                    {Tooltip(`reboot-${index}`, 'Reboot')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.lock && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`lock-${index}`}
                                                        className={`ri-phone-lock-line me-2 fs-18 ${
                                                            row.original.showActions && !row.original.disableLock
                                                                ? 'cursor-pointer link-secondary'
                                                                : 'text-muted'
                                                        }`}
                                                        onClick={() =>
                                                            row.original.showActions && !row.original.disableLock
                                                                ? props.handleDeviceLock(row, cell, index)
                                                                : undefined
                                                        }
                                                    />
                                                    {Tooltip(`lock-${index}`, 'Lock')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.map && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`mapView-${index}`}
                                                        className={`ri-road-map-line me-2 fs-18 ${
                                                            row.original.hideMapView ? 'text-muted' : 'cursor-pointer link-secondary'
                                                        }`}
                                                        onClick={
                                                            row.original.hideMapView ? undefined : () => props.handleMap(row, cell, index)
                                                        }
                                                    />
                                                    {Tooltip(`mapView-${index}`, 'See Device on Map')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.resetpassword && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`resetPassword-${index}`}
                                                        className={`ri-lock-password-line me-2 fs-18 ${
                                                            row.original.showActions && !row.original.disableResetPassword
                                                                ? 'cursor-pointer link-secondary'
                                                                : 'text-muted'
                                                        }`}
                                                        onClick={() =>
                                                            row.original.showActions && !row.original.disableResetPassword
                                                                ? props.handleResetPassword(row, cell, index)
                                                                : undefined
                                                        }
                                                    />
                                                    {Tooltip(`resetPassword-${index}`, 'Reset Password')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.scream && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`scream-${index}`}
                                                        className={`me-2 fs-18 ${
                                                            row.original.showActions && !row.original.disableScream
                                                                ? 'cursor-pointer link-secondary'
                                                                : 'text-muted'
                                                        } ${
                                                            // row.original.screamerOn ? ' ri-alarm-warning-fill mask' :
                                                            ' ri-volume-up-line'
                                                        }`}
                                                        onClick={() =>
                                                            row.original.showActions && !row.original.disableScream
                                                                ? props.handleScream(row, cell, index)
                                                                : undefined
                                                        }
                                                    />
                                                    {Tooltip(`scream-${index}`, 'Scream')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.lostMode && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`lostMode-${index}`}
                                                        className={`ri-door-lock-line me-2 fs-18 ${
                                                            !row.original.hideLostMode ? 'cursor-pointer link-secondary' : 'text-muted'
                                                        }`}
                                                        onClick={() =>
                                                            !row.original.hideLostMode ? props.handleLostMode(row, cell, index) : undefined
                                                        }
                                                    />
                                                    {Tooltip(`lostMode-${index}`, 'Lost Mode')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.factoryreset && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`factoryReset-${index}`}
                                                        className={`ri-settings-5-line me-2 fs-18 ${
                                                            !row.original.hideFactoryReset ? 'cursor-pointer link-secondary' : 'text-muted'
                                                        }`}
                                                        onClick={() =>
                                                            !row.original.hideFactoryReset
                                                                ? props.handleFactoryReset(row, cell, index)
                                                                : undefined
                                                        }
                                                    />
                                                    {Tooltip(`factoryReset-${index}`, 'Factory Reset')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.fileProgress && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`file-progress-${index}`}
                                                        onClick={() => props.handleFileProgress(row, cell, index)}
                                                        className="ri-file-chart-2-line me-2 fs-18 cursor-pointer link-secondary"
                                                    />
                                                    {Tooltip(`file-progress-${index}`, cell.column.filePorgressTooltip)}
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* spare part icon in table view */}
                                    {cell?.column?.spareParts && (
                                        <IsAuthorized
                                            privRequired={sparePartsCondition}
                                            yes={() => (
                                                <>
                                                    <div className="form-unassign form-unassign-sm">
                                                        <img
                                                            id={`spareParts-${index}`}
                                                            onClick={() => handleSparePartClick(row, cell, index)}
                                                            src={SCCL}
                                                            alt="Manage Spare Parts"
                                                            className="cursor-pointer me-2"
                                                        />
                                                        {Tooltip(`spareParts-${index}`, 'Spare Parts')}
                                                    </div>
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* request Icon in table view */}
                                    {cell?.column?.request && (
                                        <IsAuthorized
                                            privRequired={requestCondition}
                                            yes={() => (
                                                <>
                                                    <div className="form-unassign form-unassign-sm">
                                                        <img
                                                            id={`request-${index}`}
                                                            onClick={() => handleRequestClick(row, cell, index)}
                                                            src={SCCL}
                                                            alt="Requests"
                                                            className="cursor-pointer me-2"
                                                        />
                                                        {Tooltip(`request-${index}`, 'Requests')}
                                                    </div>
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* drone Icon in table view */}
                                    {cell?.column?.drone && (
                                        <IsAuthorized
                                            privRequired={droneCondition}
                                            yes={() => (
                                                <>
                                                    <div className="form-unassign form-unassign-sm">
                                                        <img
                                                            id={`drone-${index}`}
                                                            onClick={() => handleDroneClick(row, cell, index)}
                                                            src={SCCL}
                                                            alt="Drone Details"
                                                            className="cursor-pointer me-2"
                                                        />
                                                        {Tooltip(`drone-${index}`, 'Drone Details')}
                                                    </div>
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.edit && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <i
                                                    title="Edit"
                                                    id={`edit-${index}`}
                                                    className={`ri-edit-box-line me-2 fs-20 ${
                                                        row.original.editDisabled
                                                            ? 'text-muted cursor-not-allowed'
                                                            : 'cursor-pointer link-success'
                                                    }`}
                                                    aria-disabled={row.original.editDisabled}
                                                    onClick={
                                                        row.original.editDisabled ? undefined : () => props.handleEdit(row, cell, index)
                                                    }
                                                />
                                            )}
                                        />
                                    )}
                                    {cell?.column?.actionList && (
                                        <div>
                                            <IsAuthorized
                                                privRequired={props?.priv?.actionsDropDown}
                                                yes={() => (
                                                    //     <Input
                                                    //     className={`form-check-input cursor-pointer ${
                                                    //         cell.column.className ? cell.column.className : ''
                                                    //     }`}
                                                    //     type="checkbox"
                                                    //     role="switch"
                                                    //     name={'status'}
                                                    //     id={`switch-${index}`}
                                                    //     disabled={row.original.disabled}
                                                    //     onChange={(e: any) => props.onClickSwitch(row, cell, index)}
                                                    //     checked={row.original.isActive}
                                                    // />

                                                    <div>
                                                        <Dropdown isOpen={openDropdownIndex === index} toggle={() => toggleDropdown(index)}>
                                                            <DropdownToggle tag={'div'}>
                                                                {' '}
                                                                <img id={'allAction-' + index} src={actionList} alt="action-list" />
                                                            </DropdownToggle>
                                                            <DropdownMenu container="body">
                                                                <IsAuthorized
                                                                    privRequired={props?.priv?.sources}
                                                                    yes={() => (
                                                                        <DropdownItem
                                                                            className="fw-400"
                                                                            onClick={(e: any) => props.handleDetails(row, cell, index)}
                                                                        >
                                                                            <img src={details} alt="details" className="me-2" />
                                                                            Details
                                                                        </DropdownItem>
                                                                    )}
                                                                />
                                                                <IsAuthorized
                                                                    privRequired={props?.priv?.edit}
                                                                    yes={() => (
                                                                        <DropdownItem
                                                                            className="fw-400"
                                                                            onClick={(e: any) => props.handleEdit(row, cell, index)}
                                                                            disabled={props?.disabledbtn}
                                                                        >
                                                                            <img src={editM} alt="details" className="me-2" />
                                                                            Edit
                                                                        </DropdownItem>
                                                                    )}
                                                                />
                                                                <IsAuthorized
                                                                    privRequired={props?.priv?.delete}
                                                                    yes={() => (
                                                                        <DropdownItem
                                                                            className="fw-400"
                                                                            onClick={(e: any) => props.handleDelete(row, cell, index)}
                                                                            disabled={props?.disabledbtn}
                                                                        >
                                                                            <img src={deleteM} alt="details" className="me-2" />
                                                                            Delete
                                                                        </DropdownItem>
                                                                    )}
                                                                />
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </div>
                                                )}
                                            />
                                            <IsAuthorized
                                                privRequired={props?.priv?.viewMines}
                                                yes={() => (
                                                    <>
                                                        <img
                                                            id={`view-${index}`}
                                                            src={view}
                                                            alt="view"
                                                            className="me-2"
                                                            onClick={() => props.handleServiceView(row, cell, index)}
                                                        />
                                                        {Tooltip(`view-${index}`, 'View')}
                                                    </>
                                                )}
                                            />
                                        </div>
                                    )}
                                    {/* unassign icon in table view */}
                                    {cell?.column?.unAssign && (
                                        <IsAuthorized
                                            privRequired={unAssignCondition}
                                            yes={() => (
                                                <>
                                                    <span>
                                                        <div className="form-unassign form-unassign-sm">
                                                            <Button
                                                                outline
                                                                color="danger"
                                                                className=" border-danger fs-6 me-2"
                                                                id={`unAssign-${index}`}
                                                                onClick={() => props.onClickUnassign(row, cell, index)}
                                                            >
                                                                Unassign
                                                            </Button>
                                                        </div>
                                                    </span>
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* download each file in table view */}
                                    {cell?.column?.downloadFile && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`downloadFile-${index}`}
                                                        onClick={
                                                            row.original.downloadDisabled
                                                                ? undefined
                                                                : () => props.handleDownloadFile(row, cell, index)
                                                        }
                                                        className={`ri-download-2-line me-2 fs-18 ${
                                                            row.original.downloadDisabled
                                                                ? 'text-muted cursor-not-allowed'
                                                                : 'cursor-pointer link-primary'
                                                        }`}
                                                        aria-disabled={row.original.downloadDisabled}
                                                    />
                                                    {Tooltip(`downloadFile-${index}`, 'Download')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* assign/reassign button in table view */}
                                    {cell?.column?.assign && (
                                        <IsAuthorized
                                            privRequired={assignCondition}
                                            yes={() => (
                                                <div className="form-assign form-assign-sm">
                                                    <Button
                                                        color="primary"
                                                        className={`border-primary fs-6 me-2 ${
                                                            row.original.assignDisabled ? 'text-muted cursor-not-allowed' : 'cursor-pointer'
                                                        }`}
                                                        id={`assign-${index}`}
                                                        onClick={
                                                            row.original.assignDisabled
                                                                ? undefined
                                                                : () => props.onClickAssign(row, cell, index)
                                                        }
                                                        disabled={row.original.assignDisabled}
                                                    >
                                                        Assign
                                                    </Button>
                                                </div>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.switch && (
                                        <span>
                                            <div className="form-switch form-switch-sm">
                                                <Input
                                                    className={`form-check-input cursor-pointer ${
                                                        cell.column.className ? cell.column.className : ''
                                                    }`}
                                                    type="checkbox"
                                                    role="switch"
                                                    name={'status'}
                                                    id={`switch-${index}`}
                                                    disabled={row.original.disabled}
                                                    onChange={(e: any) => props.onClickSwitch(row, cell, index)}
                                                    checked={row.original.isActive}
                                                />
                                                {/* {Tooltip(`switch-${index}`, row.original.isActive ? 'Active' : 'Inactive')} */}
                                            </div>
                                        </span>
                                    )}
                                    {cell?.column?.editFadable && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`editFadable-${index}`}
                                                        className={`ri-edit-box-line me-1 fs-18 ${
                                                            row.original[cell.column.fadeEdit]
                                                                ? 'text-muted'
                                                                : ' cursor-pointer link-secondary'
                                                        }`}
                                                        onClick={() => {
                                                            if (!row.original[cell.column.fadeEdit]) props.handleEdit(row, cell, index);
                                                        }}
                                                    />
                                                    {Tooltip(
                                                        `editFadable-${index}`,
                                                        row.original[cell.column.fadeEdit]
                                                            ? cell.column.fadeTooltipKeyEdit
                                                                ? row.original?.[cell.column?.fadeTooltipKeyEdit]
                                                                : cell.column.fadeTooltip
                                                                ? cell.column.fadeTooltip
                                                                : 'Edit'
                                                            : 'Edit'
                                                    )}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.clone && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`clone-${index}`}
                                                        className="ri-file-copy-2-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleClone(row, cell, index)}
                                                    />
                                                    {Tooltip(`clone-${index}`, 'Clone')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.clone1 && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`clone-${index}`}
                                                        className="ri-file-copy-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleClone(row, cell, index)}
                                                    />
                                                    {Tooltip(`clone-${index}`, 'Clone')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.urlDownload && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`urlExport-${index}`}
                                                        className="ri-file-upload-line link-secondary fs-18 cursor-pointer me-2"
                                                        onClick={() => props.handleDownloadFirewall(row)}
                                                    />
                                                    {Tooltip(`urlExport-${index}`, 'Export as CSV File')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell.column.rename && !row.original.hideRename && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`rename-${index}`}
                                                        onClick={() => props.handleRename(row, cell, index)}
                                                        className="ri-edit-line me-2 fs-18 cursor-pointer link-secondary"
                                                    />
                                                    {Tooltip(`rename-${index}`, 'Rename')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell.column.move && !row.original.hideMove && (
                                        <IsAuthorized
                                            privRequired={props.type === 'adminAccess' ? props.adminAccess : editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`move-${index}`}
                                                        onClick={() => props.handleMove(row, cell, index)}
                                                        className={`ri-folder-transfer-line me-2 fs-18 cursor-pointer ${
                                                            row.original.delete ? 'link-danger' : 'link-secondary'
                                                        }`}
                                                    />
                                                    {Tooltip(`move-${index}`, cell.column.moveTooltip)}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell.column.treeView && (
                                        <>
                                            <i
                                                className="ri-node-tree link-secondary cursor-pointer fs-18 me-2"
                                                id={`tree-${index}`}
                                                onClick={() => props.handleTreeView(row, cell)}
                                            />
                                            {Tooltip(`tree-${index}`, 'Tree View')}
                                        </>
                                    )}
                                    {cell.column.deleteOnCount && !row.original.hideDelete && (
                                        <IsAuthorized
                                            privRequired={props.type === 'adminAccess' ? props.adminAccess : editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        title="Delete"
                                                        id={`delete-${index}`}
                                                        onClick={() => props.handleDelete(row, cell, index)}
                                                        className={`ri-delete-bin-line me-2 fs-18 cursor-pointer ${
                                                            row.original.delete ? 'link-danger' : 'link-secondary'
                                                        }`}
                                                    />
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.config && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`config-${index}`}
                                                        className={`ri-file-settings-line me-1 fs-18 ${
                                                            row.original[cell.column.configFade]
                                                                ? 'text-muted'
                                                                : ' cursor-pointer link-secondary'
                                                        }`}
                                                        onClick={() => props.handleIconView(row, cell)}
                                                    />
                                                    {Tooltip(
                                                        `config-${index}`,
                                                        row.original[cell.column.configFade]
                                                            ? cell.column.configTooltip
                                                            : 'Add Managed Configuration'
                                                    )}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.refresh && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`refresh-${index}`}
                                                        className={`ri-compass-discover-line me-2 fs-18 ${
                                                            row.original[cell.column.noUpdate]
                                                                ? 'text-muted'
                                                                : ' cursor-pointer link-secondary'
                                                        }`}
                                                        onClick={() => {
                                                            if (!row.original[cell.column.noUpdate]) props.handleRefresh(row, cell, index);
                                                        }}
                                                    />
                                                    {Tooltip(
                                                        `refresh-${index}`,
                                                        row.original[cell.column.noUpdate] ? 'No Apps Installed' : 'Update'
                                                    )}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.deleteFadable && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`deleteFadable-${index}`}
                                                        className={`ri-delete-bin-line me-1 fs-18 ${
                                                            row.original[cell.column.fade] ? 'text-muted' : ' cursor-pointer link-secondary'
                                                        }`}
                                                        onClick={() => {
                                                            if (!row.original[cell.column.fade]) props.handleDelete(row, cell, index);
                                                        }}
                                                    />
                                                    {Tooltip(
                                                        `deleteFadable-${index}`,
                                                        row.original[cell.column.fade]
                                                            ? cell.column.fadeTooltip
                                                                ? cell.column.fadeTooltip
                                                                : cell.column.fadeTooltipKeyDelete
                                                                ? row.original?.[cell.column?.fadeTooltipKeyDelete]
                                                                : 'Delete'
                                                            : 'Delete'
                                                    )}
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* {cell?.column?.delete && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        title="Delete"
                                                        id={`delete-${index}`}
                                                        className="ri-delete-bin-line fs-18 cursor-pointer link-danger"
                                                        onClick={() => props.handleDelete(row, cell, index)}
                                                    />
                                                </>
                                            )}
                                        />
                                    )} */}
                                    {cell?.column?.delete && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <i
                                                    title="Delete"
                                                    id={`delete-${index}`}
                                                    className={`ri-delete-bin-line fs-18 ${
                                                        row.original.deleteDisabled
                                                            ? 'text-muted cursor-not-allowed'
                                                            : 'cursor-pointer link-danger'
                                                    }`}
                                                    aria-disabled={row.original.deleteDisabled}
                                                    onClick={
                                                        row.original.deleteDisabled ? undefined : () => props.handleDelete(row, cell, index)
                                                    }
                                                />
                                            )}
                                        />
                                    )}
                                    {row.original.rowDelete && cell?.column?.rowDelete && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        title="Delete"
                                                        id={`delete-${index}`}
                                                        className="ri-delete-bin-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleDelete(row, cell, index)}
                                                    />
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.download && (
                                        <IsAuthorized
                                            privRequired={reader}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`downloadbulk-${index}`}
                                                        className="ri-file-upload-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleBulkDownload(row, cell, index)}
                                                    />
                                                    {Tooltip(
                                                        `downloadbulk-${index}`,
                                                        cell.column.downloadTooltip ? cell.column.downloadTooltip : 'Export'
                                                    )}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.settings && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        title="Manage Assets"
                                                        id={`settings-${index}`}
                                                        className="ri-settings-3-line me-2 fs-20 cursor-pointer link-success"
                                                        onClick={() => props.handleSetting(row, cell, index)}
                                                    />
                                                    {Tooltip(`settings-${index}`, 'Manage Assets')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* in activation comment for table view */}
                                    {cell?.column?.comment && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    {!row?.original?.isActive && (
                                                        <span>
                                                            <i
                                                                className="ri-message-2-line cursor-pointer text-primary fs-18"
                                                                id={`pop-${index}`}
                                                            ></i>
                                                            <UncontrolledPopover placement="bottom" target={`pop-${index}`}>
                                                                <PopoverHeader className="fs-8">Inactive Comment</PopoverHeader>
                                                                <PopoverBody>{row?.original?.comment}</PopoverBody>
                                                            </UncontrolledPopover>
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        />
                                    )}
                                    {/* farmer icon in clients table */}
                                    {cell?.column?.farmer && (
                                        <IsAuthorized
                                            privRequired={farmerCondition}
                                            yes={() => (
                                                <>
                                                    <div className="form-unassign form-unassign-sm">
                                                        <img
                                                            id={`farmer-${index}`}
                                                            onClick={() => handleFarmers(row, cell, index)}
                                                            src={SCCL}
                                                            alt="Farmers"
                                                            className="cursor-pointer me-2"
                                                        />
                                                        {Tooltip(`farmer-${index}`, 'Farmers')}
                                                    </div>
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.qrCode && !row.original.hideQR && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <>
                                                    <i
                                                        id={`qrcode-${index}`}
                                                        className="ri-qr-code-line me-2 fs-18 cursor-pointer link-secondary"
                                                        onClick={() => props.handleQR(row, cell, index)}
                                                    />
                                                    {Tooltip(`qrcode-${index}`, 'QR Code')}
                                                </>
                                            )}
                                        />
                                    )}
                                    {cell?.column?.shareWithText && (
                                        <IsAuthorized
                                            privRequired={editor}
                                            yes={() => (
                                                <span
                                                    className="d-flex align-items-center cursor-pointer"
                                                    onClick={() => props.handleShare(row, cell, index)}
                                                >
                                                    <span className="text-secondary fs-14 fw-semibold me-2">
                                                        {cell.render('Cell')} {cell.column.text ? cell.column.text : ''}
                                                    </span>
                                                    <i id={`share-${index}`} className="ri-share-fill me-2 fs-18 link-secondary" />
                                                    {Tooltip(`share-${index}`, 'Share')}
                                                </span>
                                            )}
                                        />
                                    )}
                                </div>
                            )
                        )}
                    </>
                );
                break;
            case 'takeAction':
                body = (
                    <div className="d-flex gap-2 align-items-center">
                        {row.original?.[cell.column.hideTakeAction] ? (
                            <></>
                        ) : (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <Button
                                        size="sm"
                                        type="button"
                                        id="takeAction"
                                        color={cell.column.takeActionClass ? cell.column.takeActionClass : 'success'}
                                        onClick={() => props.handleTakeAction(row, cell, index)}
                                    >
                                        <span className="d-flex align-items-center">
                                            {row.original.takeActionText ? row.original.takeActionText : 'Take Action'}
                                        </span>
                                    </Button>
                                )}
                            />
                        )}
                        {row.original?.[cell.column.showReassign] ? (
                            <Button
                                size="sm"
                                type="button"
                                id="takeAction"
                                outline
                                color={cell.column.takeActionClass ? cell.column.takeActionClass : 'success'}
                                onClick={() => props.handleToReassign(row, cell, index)}
                            >
                                <span className="d-flex align-items-center gap-1">
                                    <i className="ri-user-shared-2-fill"></i>
                                    <span>Reassign</span>
                                </span>
                            </Button>
                        ) : (
                            <></>
                        )}

                        {/* {row.original?.[cell.column.showEdit] ? (
                            <>
                                <i
                                    title="Edit"
                                    id={`edit-${index}`}
                                    className="ri-edit-box-line  fs-20 cursor-pointer link-success"
                                    aria-disabled={row.original.disabled}
                                    onClick={() => props.handleEdit(row, cell, index)}
                                />
                            </>
                        ) : (
                            <></>
                        )} */}
                        {row.original?.[cell.column.showEdit] ? (
                            <>
                                <i
                                    title="Edit"
                                    id={`edit-${index}`}
                                    className={`ri-edit-box-line fs-20 ${
                                        row.original.editDisabled ? 'text-muted cursor-not-allowed' : 'cursor-pointer link-success'
                                    }`}
                                    aria-disabled={row.original.editDisabled}
                                    onClick={row.original.editDisabled ? undefined : () => props.handleEdit(row, cell, index)}
                                />
                            </>
                        ) : null}

                        {row.original?.[cell.column.hideSetting] ? (
                            <>
                                <i
                                    title="Manage Assets"
                                    id={`settings-${index}`}
                                    className="ri-settings-3-line fs-20 cursor-pointer link-success"
                                    onClick={() => props.handleSetting(row, cell, index)}
                                />
                            </>
                        ) : (
                            <></>
                        )}

                        {row.original?.[cell.column.showUnpair] ? (
                            <>
                                <img
                                    src={SCCL}
                                    alt="unpair batteries"
                                    // className="cursor-pointer link-success"
                                    className={`ri-edit-box-line fs-20 ${
                                        row.original.unpairDisabled ? 'text-muted cursor-not-allowed' : 'cursor-pointer link-success'
                                    }`}
                                    aria-disabled={row.original.unpairDisabled}
                                    onClick={row.original.unpairDisabled ? undefined : () => props.handleUnpairBatteries(row, cell, index)}
                                    // onClick={() => props.handleUnpairBatteries(row, cell, index)}
                                    title="Unpair Batteries"
                                    id={`unpair-${index}`}
                                    height="18px"
                                />
                                {/* {Tooltip(`unpair-${index}`, 'Unpair Batteries')} */}
                            </>
                        ) : (
                            <></>
                        )}

                        {row.original?.[cell.column.unassign] && (
                            <>
                                <Button
                                    size="sm"
                                    type="button"
                                    outline
                                    color={cell.column.takeActionClass ? cell.column.takeActionClass : 'danger'}
                                    onClick={() => props.handleUnassign(row, cell, index)}
                                    disabled
                                >
                                    <span className="d-flex align-items-center gap-1">
                                        <span>Unassign</span>
                                    </span>
                                </Button>
                            </>
                        )}

                        {row.original?.[cell.column.hideSwitch] ? (
                            <></>
                        ) : (
                            <span>
                                <div className="form-switch form-switch-sm">
                                    <Input
                                        className={`form-check-input cursor-pointer ${cell.column.className ? cell.column.className : ''}`}
                                        type="checkbox"
                                        role="switch"
                                        name={'status'}
                                        title="Active/Inactive Status"
                                        id={`switch-${index}`}
                                        disabled={row.original.disabled}
                                        onChange={(e: any) => props.onClickSwitch(row, cell, index)}
                                        checked={row.original.isActive}
                                    />
                                    {/* {Tooltip(`switch-${index}`, row.original.isActive ? 'Active' : 'Inactive')} */}
                                </div>
                            </span>
                        )}

                        {row.original?.[cell.column.showTrackButton] ? (
                            <Button
                                size="sm"
                                type="button"
                                outline
                                color={cell.column.takeActionClass ? cell.column.takeActionClass : 'success'}
                                onClick={() => props.handleToTrack(row, cell, index)}
                                disabled
                            >
                                <span className="d-flex align-items-center gap-1">
                                    <i className="ri-map-pin-user-fill"></i>
                                    <span>Track</span>
                                </span>
                            </Button>
                        ) : (
                            <></>
                        )}
                        {row.original?.[cell.column.showComment] ? (
                            <>
                                <i id={`comment-${index}`} className="ri-message-2-line  fs-20 cursor-pointer link-success" />

                                <UncontrolledPopover placement="bottom" target={`comment-${index}`}>
                                    <PopoverBody className="fs-11">{row.original.comment}</PopoverBody>
                                </UncontrolledPopover>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                );
                break;
            case 'statusDots':
                body = (
                    <div className="d-flex align-items-center justify-content-center fw-medium">
                        <i
                            className={`ri-checkbox-blank-circle-fill link-${row.original.onlineStatusClass} me-3`}
                            id={`onlineStatus-${index}`}
                        />
                        {!cell.column.hideTooltip && Tooltip(`onlineStatus-${index}`, row.original?.[cell.column?.onlineStatusTooltip])}
                        {/* <i
                            className={`ri-checkbox-blank-circle-fill link-${row.original.enrollmentStatusClass} link-info`}
                            id={`registration-${index}`}
                        />
                        {Tooltip(`registration-${index}`, row.original?.[cell.column?.enrollmentStatusTooltip])} */}
                    </div>
                );
                break;
            case 'checkbox':
                body = (
                    <div className={`d-flex align-items-center justify-content-center ${cell.column.className}`}>
                        {(cell.column.disable ? (row.original[cell.column.disable] ? true : false) : true) ? (
                            <input
                                type="checkbox"
                                checked={cell.column.checkedAccessor ? row.original?.[cell.column.checkedAccessor] : row.original.checked}
                                disabled={
                                    props.mode === 'view' ||
                                    (cell.column.disable
                                        ? !row.original[cell.column.disable]
                                        : row.original.disable
                                        ? row.original.disable
                                        : false)
                                }
                                className={
                                    'form-check-input cursor-pointer' +
                                    (cell.column.disable
                                        ? row.original[cell.column.disable]
                                            ? 'border border-primary'
                                            : 'border border-danger'
                                        : 'border border-primary')
                                }
                                onChange={(e: any) => props?.handleCheckboxChange(e, index, row, cell)}
                            />
                        ) : (
                            'NA'
                        )}
                    </div>
                );
                break;
            case 'radio':
                body = (props.hideRadio ? !row.original.hideRadio : true) && (
                    <div className={`d-flex align-items-center justify-content-center ${cell.column.className}`}>
                        <input
                            type="radio"
                            checked={row.original.checked}
                            className="form-check-input border-primary"
                            onClick={(e: any) => props.handleRadioChange(e, index, row, cell)}
                        />
                    </div>
                );
                break;
            case 'tooltip':
                body = (
                    <div className="d-flex align-items-center justify-content-center">
                        <span>{row.original[cell.column.id]}</span>
                    </div>
                );
                break;
            case 'status':
                body = (
                    <Row
                        className={`d-flex align-items-center ${row.original[cell.column.accessor2] > 0 ? ' cursor-pointer' : ''}`}
                        onClick={() => {
                            if (row.original[cell.column.accessor2] > 0) props.handleCountViewPolicy(row, index, cell);
                        }}
                    >
                        <Col sm={'3'} className="d-flex align-items-center text-truncate">
                            <div className="d-flex align-items-center text-truncate" id={`key3-${index}`}>
                                <i className="ri-checkbox-blank-circle-fill link-success me-1" />
                                <span>{row.original?.[cell.column.key3]}</span>
                            </div>
                            {Tooltip(`key3-${index}`, 'Latest: ' + row.original?.[cell.column.key3])}
                        </Col>
                        <Col sm={'3'} className="d-flex align-items-center justify-content-center text-truncate">
                            <div className="d-flex align-items-center text-truncate" id={`key2-${index}`}>
                                <i className="ri-checkbox-blank-circle-fill link-warning me-1" />
                                <span>{row.original?.[cell.column.key2]}</span>
                            </div>
                            {Tooltip(`key2-${index}`, 'Not Latest: ' + row.original?.[cell.column.key2])}
                        </Col>
                        <Col sm={'3'} className="d-flex align-items-center justify-content-end text-truncate">
                            <div className="d-flex align-items-center text-truncate" id={`key1-${index}`}>
                                <i className="ri-checkbox-blank-circle-fill link-danger me-1" />
                                <span>{row.original?.[cell.column.key1]}</span>
                            </div>
                            {Tooltip(`key1-${index}`, 'Not Installed: ' + row.original?.[cell.column.key1])}
                        </Col>
                    </Row>
                );
                break;
            case 'download':
                body = (
                    <div className="d-flex align-items-center">
                        {/* <i
                            className="ri-file-upload-line cursor-pointer link-success fs-18 me-2"
                            onClick={() => props.handleDownload(row, '3')}
                            id={`downloadLatestDevices-${index}`}
                        />
                        {Tooltip(`downloadLatestDevices-${index}`, 'Export as CSV File')} */}
                        <i
                            className="ri-file-upload-line cursor-pointer link-warning fs-18 me-2"
                            onClick={() => props.handleDownload(row, '2')}
                            id={`downloadNotLatestDevices-${index}`}
                        />
                        {Tooltip(`downloadNotLatestDevices-${index}`, 'Export as CSV File')}
                        <i
                            className="ri-file-upload-line cursor-pointer link-danger fs-18"
                            onClick={() => props.handleDownload(row, '1')}
                            id={`downloadNotInstalledDevices-${index}`}
                        />
                        {Tooltip(`downloadNotInstalledDevices-${index}`, 'Export as CSV File')}
                    </div>
                );
                break;
            case 'fileDownload':
                body = (
                    <div className="d-flex align-items-center">
                        <i
                            className="ri-download-2-line cursor-pointer link-success fs-18 me-2"
                            onClick={() => props.handleFileDownload(cell, row, 'download')}
                            id={`download-${index}`}
                        />
                        {Tooltip(`download-${index}`, 'Download File')}
                        <span
                            className="fw-medium link-primary cursor-pointer me-2 word-ellipsis"
                            onClick={() => props.handleFileDownload(cell, row, 'download')}
                        >
                            <EllipsisToolTip options={{ effect: 'solid', place: 'bottom' }}>{cell.render('Cell')}</EllipsisToolTip>
                        </span>
                    </div>
                );
                break;
            case 'coloredTextWithLink':
                body = (
                    <>
                        <span
                            id={`coloredTextWithLink-${index}-${cell.column.keyVal}`}
                            className={`text-${cell.column?.textClass} text-decoration-underline cursor-pointer`}
                            onClick={() => props.handleCountClick(row, cell)}
                        >
                            {cell.render('Cell')}
                        </span>
                        {Tooltip(`coloredTextWithLink-${index}-${cell.column.keyVal}`, cell.column.tooltip)}
                    </>
                );
                break;
            case 'priviliges':
                body = (
                    <div className="text-secondary fw-medium">
                        <span className="me-2 cursor-pointer" onClick={() => props.handlePriviligeView(row)}>
                            View ({cell.render('Cell')})
                        </span>
                    </div>
                );
                break;
            case 'infoText':
                body = (
                    <div className="d-flex align-items-center gap-2">
                        <span>{cell.render('Cell')}</span>
                        {row.original?.[cell.column.showTooltipKey] && (
                            <>
                                <i className="ri-information-line link-primary" id={`infoText-${index}`} />
                                {Tooltip(`infoText-${index}`, row.original?.[cell.column.infoTooltip])}
                            </>
                        )}
                    </div>
                );
                break;
            case 'policyCompliance':
                body = (
                    <div className="d-flex align-items-center gap-2">
                        <i className={`ri-checkbox-blank-circle-fill ${row.original?.[cell.column.circleClass]}`} />
                        {cell.render('Cell')}
                    </div>
                );
                break;
            case 'chromeActions':
                body = row.original.hideActions ? (
                    <>
                        {cell.column.onHideAction ? (
                            <span className={`lh-sm badge badge-soft-${row.original[cell.column.onHideClass]}`}>
                                {row.original[cell.column.onHideAction]}
                            </span>
                        ) : (
                            '—'
                        )}
                    </>
                ) : (
                    <div className="d-flex align-items-center">
                        {cell?.column?.devicemove && (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <>
                                        <i
                                            id={`devicemove-${index}`}
                                            className={`ri-folder-transfer-line me-2 fs-18 ${
                                                !row.original.hideMove ? 'cursor-pointer link-secondary' : 'text-muted'
                                            }`}
                                            onClick={() => (!row.original.hideMove ? props.handleMove(row, cell, index) : undefined)}
                                        />
                                        {Tooltip(`devicemove-${index}`, 'Move')}
                                    </>
                                )}
                            />
                        )}
                        {cell?.column?.screenshot && (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <>
                                        <i
                                            id={`screenshot-${index}`}
                                            className={`ri-screenshot-2-line me-2 fs-18 ${
                                                !row.original.hideScreenshot ? 'cursor-pointer link-secondary' : 'text-muted'
                                            }`}
                                            onClick={() =>
                                                !row.original.hideScreenshot ? props.handleScreenshot(row, cell, index) : undefined
                                            }
                                        />
                                        {Tooltip(`screenshot-${index}`, 'Take Screenshot')}
                                    </>
                                )}
                            />
                        )}
                        {cell?.column?.reboot && (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <>
                                        <i
                                            id={`reboot-${index}`}
                                            className={`ri-creative-commons-sa-line me-2 fs-18 ${
                                                row.original.showActions ? 'cursor-pointer link-secondary' : 'text-muted'
                                            }`}
                                            onClick={() =>
                                                row.original.showActions ? props.handleDeviceReboot(row, cell, index) : undefined
                                            }
                                        />
                                        {Tooltip(`reboot-${index}`, 'Reboot')}
                                    </>
                                )}
                            />
                        )}
                        {cell?.column?.volume && (
                            <IsAuthorized
                                privRequired={reader}
                                yes={() => (
                                    <>
                                        <i
                                            id={`volume-${index}`}
                                            className={`me-2 fs-18 ${
                                                row.original.showActions ? 'cursor-pointer link-secondary' : 'text-muted'
                                            } ${
                                                // row.original.screamerOn ? ' ri-alarm-warning-fill mask' :
                                                ' ri-volume-up-line'
                                            }`}
                                            onClick={() =>
                                                row.original.showActions ? props.handleVolume(row, cell, index, 'START') : undefined
                                            }
                                        />
                                        {Tooltip(`volume-${index}`, 'Volume')}
                                    </>
                                )}
                            />
                        )}
                        {cell?.column?.deprovision && (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <>
                                        <i
                                            id={`deprovision-${index}`}
                                            className={`ri-link-unlink-m me-2 fs-18 ${
                                                !row.original.hidedeoprovision ? 'cursor-pointer link-secondary' : 'text-muted'
                                            }`}
                                            onClick={() =>
                                                !row.original.hidedeoprovision ? props.handleDeprovision(row, cell, index) : undefined
                                            }
                                        />
                                        {Tooltip(`deprovision-${index}`, 'Deprovision')}
                                    </>
                                )}
                            />
                        )}
                        {cell?.column?.wipeUser && (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <>
                                        <i
                                            id={`wipeuser-${index}`}
                                            className={`ri-user-settings-line me-2 fs-18 ${
                                                !row.original.hideWipeUser ? 'cursor-pointer link-secondary' : 'text-muted'
                                            }`}
                                            onClick={() =>
                                                !row.original.hideWipeUser ? props.handleWipeUser(row, cell, index) : undefined
                                            }
                                        />
                                        {Tooltip(`wipeuser-${index}`, 'Wipe User')}
                                    </>
                                )}
                            />
                        )}
                        {cell?.column?.factoryreset && (
                            <IsAuthorized
                                privRequired={editor}
                                yes={() => (
                                    <>
                                        <i
                                            id={`factoryReset-${index}`}
                                            className={`ri-settings-5-line me-2 fs-18 ${
                                                !row.original.hideFactoryReset ? 'cursor-pointer link-secondary' : 'text-muted'
                                            }`}
                                            onClick={() =>
                                                !row.original.hideFactoryReset ? props.handleFactoryReset(row, cell, index) : undefined
                                            }
                                        />
                                        {Tooltip(`factoryReset-${index}`, 'Factory Reset')}
                                    </>
                                )}
                            />
                        )}
                    </div>
                );
                break;
            case 'tasks':
                body = (
                    <IsAuthorized
                        privRequired={editor}
                        yes={() => (
                            <>
                                <div className="d-flex align-items-center gap-2 ">
                                    <div
                                        className={`text-info ${row.original.reassign ? 'link-info cursor-pointer' : 'link-soft-info'}`}
                                        onClick={() => (row.original.reassign ? props.handleReAssign(row) : undefined)}
                                    >
                                        <i className="ri-user-shared-2-line" />
                                        <span>Reassign</span>
                                    </div>
                                    <div
                                        className={`text-danger ${row.original.cancel ? 'link-danger cursor-pointer' : 'link-soft-danger'}`}
                                        onClick={() => (row.original.cancel ? props.handleCancel(row) : undefined)}
                                    >
                                        <i className="ri-close-circle-line" />
                                        <span>Cancel</span>
                                    </div>
                                </div>
                            </>
                        )}
                    />
                );
                break;

            default:
                break;
        }
        return body;
    };

    const excludeSpecialCharInSearch = (e: any) => {
        let resultRegex;
        if (props?.searchFilterRegexValue) {
            resultRegex = new RegExp(props?.searchFilterRegexValue);
        } else {
            resultRegex = new RegExp(regex.alphaNumeric);
        }

        const valid: any = resultRegex.test(e.target.value);
        if (valid || e.target.value === '') {
            setValue(e.target.value?.replace('  ', ' '));
            setActivePage(1);
            onChange(e.target.value);
        }
    };

    const prepareCustomHeader = (column: {
        headerType: any;
        showHeader: any;
        thClass: any;
        Header:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | Iterable<React.ReactNode>
            | React.ReactPortal
            | Iterable<React.ReactNode>
            | null
            | undefined;
        headerCheckAll: string | number;
    }) => {
        let body = undefined;
        switch (column.headerType) {
            case 'checkbox':
                body = (
                    <>
                        {column.showHeader && <div className={`d-flex justify-content-center mb-1 ${column.thClass}`}>{column.Header}</div>}
                        <div className={`d-flex justify-content-center ${column.thClass}`}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="checkbox"
                                disabled={props.mode === 'view'}
                                checked={column.headerCheckAll ? props[column.headerCheckAll] : props.checkAll}
                                onChange={(e: any) => props.handleCheckAll(e, column)}
                            />
                            {!props.hideCheckBoxTooltip && Tooltip('checkbox', 'It will select all the records of this page only.')}
                        </div>
                    </>
                );
                break;
            default:
                break;
        }
        return body;
    };

    const uploadDoc = () => {
        fileUploader.click();
    };

    const handleUpload = (val: React.ChangeEvent<HTMLInputElement> | any, type: string) => {
        const file = props.multipleUpload ? val.target.files : val.target.files[0];
        props.handleUpload && props.handleUpload(file, type);
    };

    const handleSelectChange = (val?: any) => {
        props.handleSelectChange(val || undefined);
    };

    const onChangePicker = useAsyncDebounce((val: any) => {
        props.handleDateSearch(val || undefined);
    }, 200);

    const onChange = useAsyncDebounce((val: string) => {
        if (props.handleGlobalSearch) props.handleGlobalSearch(val?.trim() || undefined, setValue);
        else setGlobalFilter(val?.trim() || undefined);
    }, 200);

    const handlePageChange = (pageNumber: any) => {
        setActivePage(pageNumber);
        const pg = pageNumber ? Number(pageNumber) - 1 : 0;
        gotoPage(pg);
        onPageChange && onPageChange(pageNumber, pageSize);
    };

    const booking: any = (cell: any) => {
        if (cell.column.isBooking) {
            if (cell.column.color) {
                return (
                    <div>
                        <div className={`text-primary ${cell.column.color} cursor-pointer`}> {cell.render('Cell')} </div>
                    </div>
                );
            }
            if (cell.column.isBookingStatus && cell.value === 'Open') {
                return (
                    <Button type="button" className={'badge btn btn-light text-danger'}>
                        {cell.value}
                    </Button>
                );
            } else if (cell.column.isBookingStatus && cell.value === 'Assigned') {
                return (
                    <Button type="button" className={'badge btn btn-light text-primary'}>
                        {cell.value}
                    </Button>
                );
            } else if (cell.column.isBookingStatus && cell.value === 'INPROGRESS') {
                return (
                    <Button type="button" className={'badge btn btn-light text-primary'}>
                        {cell.value}
                    </Button>
                );
            } else if (cell.column.isBookingStatus && cell.value === 'Completed') {
                return (
                    <Button type="button" className={'badge btn btn-light text-success'}>
                        {cell.value}
                    </Button>
                );
            }
        }

        if (cell.column.isServiceCenterID) {
            if (cell.column.color) {
                return (
                    <div>
                        {/* <div className={`text-primary ${cell.column.color} cursor-pointer`} onClick={() => navigate('/usertable')}>
                            {' '}
                            {cell.render('Cell')}{' '}
                        </div> */}
                    </div>
                );
            }
            // ServiceTable actions
            if (cell.column.isCustom) {
                if (cell.column.Header === 'Actions') {
                    return (
                        <>
                            <div className="d-flex align-items-center gap-2">
                                <i className="ri-edit-box-line text-success fs-20"></i>
                                <div className="form-switch form-switch-sm">
                                    <Input
                                        className={`form-check-input cursor-pointer  ${cell.column.className ? cell.column.className : ''}`}
                                        type="checkbox"
                                        role="switch"
                                        name={'status'}
                                    />
                                </div>
                            </div>
                        </>
                    );
                }
            }
        }
        // UserTable actions
        if (cell.column.isCustom) {
            if (cell.column.Header === 'Actions') {
                return (
                    <>
                        <div className="d-flex align-items-center gap-2">
                            <i className="ri-edit-box-line text-success fs-20"></i>
                            <div className="form-switch form-switch-sm">
                                <Input
                                    className={`form-check-input cursor-pointer  ${cell.column.className ? cell.column.className : ''}`}
                                    type="checkbox"
                                    role="switch"
                                    name={'status'}
                                />
                            </div>
                        </div>
                    </>
                );
            }
        }
        // AssetsData actions
        if (cell.column.isAssets) {
            if (cell.column.Header === 'Actions') {
                return (
                    <>
                        <div>
                            <i className="ri-delete-bin-6-line text-danger fs-20"></i>
                        </div>
                    </>
                );
            }
        } else {
            return cell.render('Cell');
        }
    };

    const TopFilterPanel = () => {
        return (
            <Col sm="auto" className="d-flex align-items-center justify-content-between">
                <Row className="g-2 align-items-center">
                    {tableHeader &&
                        (props.tableHeaderBody ? (
                            props.tableHeaderBody
                        ) : (
                            <Col className="d-flex justify-content-start">
                                {props.headerImage && <img src={props.headerImage} alt=""></img>}
                                <h4
                                    className={`card-title mb-0 ${props.headerImage ? 'ps-2' : ''} ${
                                        props.tableLabelClass ? props.tableLabelClass : ''
                                    }`}
                                >
                                    {tableHeader}
                                    {!props.hideDisplayTotalCount && `(${totalRecords ? totalRecords : globalFilteredRows?.length})`}
                                </h4>
                            </Col>
                        ))}
                    {props.searchFilter1 && (
                        <Col sm="auto">
                            <Row className="align-items-center">
                                <div className="col-sm-auto">
                                    <div className={`form-icon ${props.largeSearchFilter ? 'width-403' : ''}`}>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            maxLength={props.filter1CharLimit ? props.filter1CharLimit : ''}
                                            id="search-bar-0"
                                            value={value || ''}
                                            className={
                                                (props.showTooltip ? 'holder' : '') +
                                                ` form-control form-control-icon dash-filter-picker height-36 fs-${props?.searchPlaceholderSize}`
                                            }
                                            placeholder={`Search ${props.searchPlaceHolder ? 'by ' + props.searchPlaceHolder : ''}`}
                                            onChange={(e: any) => {
                                                excludeSpecialCharInSearch(e);
                                            }}
                                        />
                                        <i className="ri-search-line link-black"></i>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}

                    {props.dateFilter1 && (
                        <Col sm="auto">
                            <Row className="align-items-center">
                                <div className="col-sm-auto">
                                    <div className="form-icon flex-nowrap">
                                        <Flatpickr
                                            ref={fp}
                                            value={dateVal}
                                            placeholder={`Search${props.datePlaceHolder1}`}
                                            className={'form-control form-control-icon w-100 date-filter-picker'}
                                            options={{ mode: 'single', dateFormat: 'd M, Y' }}
                                            onChange={(e: any) => {
                                                setDateVal(e);
                                                setActivePage(1);
                                                onChangePicker(e);
                                            }}
                                        />
                                        <i className="ri-calendar-2-line" />
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}

                    {props.dateRangeFilter1 && (
                        <Col sm="auto">
                            <Row className="align-items-center">
                                <div className="col-sm-auto">
                                    <div className={`form-icon flex-nowrap ${props.largeDateRangeFilter ? 'width-300' : ''}`}>
                                        <Flatpickr
                                            ref={fp}
                                            value={dateVal}
                                            placeholder={`Search${props.dateRangePlaceHolder1}`}
                                            className={
                                                (props.showTooltip ? 'holder' : '') +
                                                (props.dateClass ? ' ' + props.dateClass : '') +
                                                ' form-control form-control-icon w-100 date-filter-picker'
                                            }
                                            options={{
                                                mode: 'range',
                                                dateFormat: 'd M, Y',
                                                defaultDate: dateVal,
                                                maxDate: props?.isAdmin ? new Date() : props?.maxDate ? props?.maxDate : undefined // Set maxDate to today if user is admin
                                            }}
                                            onChange={(e: any) => {
                                                setDateVal(e);
                                                setActivePage(1);
                                                onChangePicker(e);
                                            }}
                                        />
                                        <i className="ri-calendar-2-line" />
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}

                    {props.dropDownFilter && (
                        <Col sm="auto">
                            <div className={`d-flex ${props.largeSearchFilter ? 'width-470' : ''}`}>
                                <div className="d-flex align-items-center px-2 fw-normal">
                                    <h5>{props.dropDownFilterLabel} </h5>
                                </div>
                                <Select
                                    getOptionValue={(option: { value: any }) => option.value}
                                    getOptionLabel={(option: { label: any }) => option.label}
                                    isMulti={props?.dropDownParams?.isMulti ? true : false}
                                    isClearable={props?.dropDownParams?.isMulti || props?.dropDownParams?.clearable ? true : false}
                                    id={props?.dropDownParams?.label}
                                    name={props?.dropDownParams?.value}
                                    options={props?.dropDownParams?.options}
                                    placeholder={`Select ${props?.dropDownParams?.label}`}
                                    onChange={(e: React.SetStateAction<undefined>) => {
                                        setDropDownValue(e);
                                        setActivePage(1);
                                        handleSelectChange(e);
                                    }}
                                    value={dropDownValue || ''}
                                    isSearchable={true}
                                    className={`dropdown-filter-picker ${props.largeSearchFilter ? 'w-100' : ''}`}
                                    classNamePrefix={'custom-select'}
                                    noOptionsMessage={() => 'No data found'}
                                />
                            </div>
                        </Col>
                    )}

                    {props.dropDownFilter4 && (
                        <Col sm="auto">
                            <div className="d-flex">
                                <Select
                                    styles={{
                                        control: (styles: any, state: { selectProps: { isDisabled: any } }) => ({
                                            ...styles,
                                            backgroundColor: state.selectProps.isDisabled ? '#f2f2f2' : 'white'
                                        }),
                                        menu: (styles: any) => ({
                                            ...styles,
                                            backgroundColor: 'white',
                                            zIndex: 999999999,
                                            lineBreak: 'anywhere',
                                            width: 'max-content',
                                            minWidth: '100%'
                                        }),
                                        option: (styles: any, { isSelected }: any) => ({
                                            ...styles,
                                            color: isSelected ? 'white' : '#000000',
                                            backgroundColor: isSelected ? '#0d807b' : null,
                                            ':hover': {
                                                ...styles[':hover'],
                                                backgroundColor: '#0d807b',
                                                color: 'white'
                                            }
                                        })
                                    }}
                                    getOptionValue={(option: { value: any }) => option.value}
                                    getOptionLabel={(option: { label: any }) => option.label}
                                    isMulti={props?.dropDownParams4?.isMulti ? true : false}
                                    isClearable={props?.dropDownParams4?.clearable ? true : false}
                                    id={props?.dropDownParams4?.label}
                                    name={props?.dropDownParams4?.value}
                                    options={props?.dropDownParams4?.options}
                                    placeholder={`Select ${props?.dropDownParams4?.label}`}
                                    onChange={(e: React.SetStateAction<undefined>) => {
                                        setDropDownValue4(e);
                                        setActivePage(1);
                                        props.handleSelectChange4(e);
                                    }}
                                    value={dropDownValue4 || ''}
                                    isSearchable={true}
                                    className="dropdown-filter-picker"
                                    classNamePrefix={'custom-select'}
                                    noOptionsMessage={() => 'No data found'}
                                />
                            </div>
                        </Col>
                    )}

                    {props.dropDownFilter3 && (
                        <Col sm="auto">
                            <div className="d-flex">
                                <Select
                                    styles={{
                                        control: (styles: any, state: { selectProps: { isDisabled: any } }) => ({
                                            ...styles,
                                            backgroundColor: state.selectProps.isDisabled ? '#f2f2f2' : 'white'
                                        }),
                                        menu: (styles: any) => ({
                                            ...styles,
                                            backgroundColor: 'white',
                                            zIndex: 999999999,
                                            lineBreak: 'anywhere',
                                            width: 'max-content',
                                            minWidth: '100%'
                                        }),
                                        singleValue: (styles: any) => ({
                                            ...styles,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            maxWidth: '100px' // Ensure ellipsis works properly
                                        }),
                                        option: (styles: any, { isSelected }: any) => ({
                                            ...styles,
                                            color: isSelected ? 'white' : '#000000',
                                            backgroundColor: isSelected ? '#0d807b' : null,
                                            ':hover': {
                                                ...styles[':hover'],
                                                backgroundColor: '#0d807b',
                                                color: 'white'
                                            }
                                        })
                                    }}
                                    getOptionValue={(option: { value: any }) => option.value}
                                    getOptionLabel={(option: { label: any }) => option.label}
                                    isMulti={props?.dropDownParams3?.isMulti ? true : false}
                                    isClearable={props?.dropDownParams3?.isMulti || props?.dropDownParams3?.clearable ? true : false}
                                    id={props?.dropDownParams3?.label}
                                    name={props?.dropDownParams3?.value}
                                    options={props?.dropDownParams3?.options}
                                    placeholder={`Select ${props?.dropDownParams3?.label}`}
                                    onChange={(e: React.SetStateAction<undefined>) => {
                                        setDropDownValue3(e);
                                        setActivePage(1);
                                        props?.handleSelectChange3(e);
                                    }}
                                    value={dropDownValue3 || ''}
                                    isSearchable={true}
                                    className="dropdown-filter-picker"
                                    classNamePrefix={'custom-select'}
                                    noOptionsMessage={() => 'No data found'}
                                />
                            </div>
                        </Col>
                    )}
                    {props.clearFiltersButton1 && (
                        <Col className="d-flex justify-content-end">
                            <Button
                                className="w-100"
                                type="button"
                                color="primary"
                                outline={true}
                                onClick={() => {
                                    props.handleClearFilters && props.handleClearFilters();
                                    setDateVal('');
                                    setValue('');
                                    setActivePage(1);
                                    setDropDownValue(null);
                                }}
                            >
                                Clear Filters
                            </Button>
                        </Col>
                    )}
                    {props.refresh && (
                        <Col sm="auto">
                            <div className="d-flex">
                                <Button
                                    type="button"
                                    color="primary"
                                    outline
                                    id="refresh"
                                    className="ps-2 pe-2 pt-1 pb-1"
                                    onClick={props.handleFilter}
                                >
                                    <span className="d-flex align-items-center fs-18">
                                        <i className="ri-refresh-line align-bottom"></i>
                                    </span>
                                </Button>
                                {Tooltip('refresh', 'Refresh')}
                            </div>
                        </Col>
                    )}
                    {props.bulkAction && (
                        <Col sm="auto">
                            <div className="d-flex" id={'bulkActionDiv'}>
                                <Button
                                    type="button"
                                    id="bulkAction"
                                    className="padding-x-9"
                                    disabled={props.disableBulkAction}
                                    color="primary"
                                    onClick={props.handleBulkAction}
                                >
                                    <span className="d-flex align-items-center">Bulk Action</span>
                                </Button>
                                {Tooltip('bulkAction', 'Perform Bulk Action')}
                            </div>
                            {props.disableBulkAction && Tooltip('bulkActionDiv', 'Please select atleast one device to perform action')}
                        </Col>
                    )}
                    {props?.back && (
                        <Col sm="auto">
                            <div className="d-flex align-items-center">
                                <div className="me-3" onClick={() => props?.handleBack()}>
                                    <i className="ri-arrow-left-line fs-20"></i>
                                </div>
                                <div className="me-5 fs-14">
                                    Service Center ID: <b> {props?.centerId} </b>
                                </div>
                                <div className="me-3 fs-14">
                                    Service Center: <b> {props?.serviceCenterName} </b>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
                <Row className="g-2 align-items-between">
                    {props.dateFilter && (
                        <Col sm="auto">
                            <Row className="align-items-center">
                                <div className="col-sm-auto">
                                    <div className="form-icon flex-nowrap">
                                        <Flatpickr
                                            ref={fp}
                                            value={dateVal}
                                            placeholder={`Search${props.datePlaceHolder}`}
                                            className={'form-control form-control-icon w-100 date-filter-picker'}
                                            options={{ mode: 'single', dateFormat: 'd M, Y' }}
                                            onChange={(e: any) => {
                                                setDateVal(e);
                                                setActivePage(1);
                                                onChangePicker(e);
                                            }}
                                        />
                                        <i className="ri-calendar-2-line" />
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}
                    {props.dropDownFilter2 && (
                        <Col sm="auto">
                            <div className="d-flex">
                                <Select
                                    styles={{
                                        control: (styles: any, state: { selectProps: { isDisabled: any } }) => ({
                                            ...styles,
                                            backgroundColor: state.selectProps.isDisabled ? '#f2f2f2' : 'white'
                                        }),
                                        menu: (styles: any) => ({
                                            ...styles,
                                            backgroundColor: 'white',
                                            zIndex: 999999999,
                                            lineBreak: 'anywhere',
                                            width: 'max-content',
                                            minWidth: '100%'
                                        }),
                                        option: (styles: any, { isSelected }: any) => ({
                                            ...styles,
                                            color: isSelected ? 'white' : '#000000',
                                            backgroundColor: isSelected ? '#0d807b' : null,
                                            ':hover': {
                                                ...styles[':hover'],
                                                backgroundColor: '#0d807b',
                                                color: 'white'
                                            }
                                        })
                                    }}
                                    getOptionValue={(option: { value: any }) => option.value}
                                    getOptionLabel={(option: { label: any }) => option.label}
                                    isMulti={props?.dropDownParams2?.isMulti ? true : false}
                                    isClearable={props?.dropDownParams2?.isMulti ? true : false}
                                    id={props?.dropDownParams2?.label}
                                    name={props?.dropDownParams2?.value}
                                    options={props?.dropDownParams2?.options}
                                    placeholder={`Select ${props?.dropDownParams2?.label}`}
                                    onChange={(e: React.SetStateAction<undefined>) => {
                                        setDropDownValue2(e);
                                        setActivePage(1);
                                        props.handleSelectChange2(e);
                                    }}
                                    value={dropDownValue2 || ''}
                                    isSearchable={true}
                                    className="dropdown-filter-picker"
                                    classNamePrefix={'custom-select'}
                                    noOptionsMessage={() => 'No data found'}
                                />
                            </div>
                        </Col>
                    )}

                    {props.dropDownFilter1 && (
                        <Col sm="auto">
                            <div className="d-flex">
                                <Select
                                    styles={{
                                        control: (styles: any, state: { selectProps: { isDisabled: any } }) => ({
                                            ...styles,
                                            backgroundColor: state.selectProps.isDisabled ? '#f2f2f2' : 'white'
                                        }),
                                        menu: (styles: any) => ({
                                            ...styles,
                                            backgroundColor: 'white',
                                            zIndex: 999999999,
                                            lineBreak: 'anywhere',
                                            width: 'max-content',
                                            minWidth: '100%'
                                        }),
                                        singleValue: (styles: any) => ({
                                            ...styles,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            maxWidth: '100px' // Ensure ellipsis works properly
                                        }),
                                        option: (styles: any, { isSelected }: any) => ({
                                            ...styles,
                                            color: isSelected ? 'white' : '#000000',
                                            backgroundColor: isSelected ? '#0d807b' : null,
                                            ':hover': {
                                                ...styles[':hover'],
                                                backgroundColor: '#0d807b',
                                                color: 'white'
                                            }
                                        })
                                    }}
                                    getOptionValue={(option: { value: any }) => option.value}
                                    getOptionLabel={(option: { label: any }) => option.label}
                                    isMulti={props?.dropDownParams1?.isMulti ? true : false}
                                    isClearable={props?.dropDownParams1?.isMulti || props?.dropDownParams1?.clearable ? true : false}
                                    id={props?.dropDownParams1?.label}
                                    name={props?.dropDownParams1?.value}
                                    options={props?.dropDownParams1?.options}
                                    placeholder={`Select ${props?.dropDownParams1?.label}`}
                                    onChange={(e: React.SetStateAction<undefined>) => {
                                        setDropDownValue1(e);
                                        setActivePage(1);
                                        handleSelectChange(e);
                                    }}
                                    value={dropDownValue1 || ''}
                                    isSearchable={true}
                                    className="dropdown-filter-picker"
                                    classNamePrefix={'custom-select'}
                                    noOptionsMessage={() => 'No data found'}
                                />
                            </div>
                        </Col>
                    )}
                    {props.searchFilter2 && (
                        <Col sm="auto">
                            <Row className="align-items-center">
                                <div className="col-sm-auto">
                                    <div
                                        className={`form-icon ${
                                            props.largeSearchFilter ? (props.SearchFilterWidth ? props.SearchFilterWidth : 'width-460') : ''
                                        }`}
                                    >
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            id={props.changeID ? 'search-bar-1-' + props.tabName : 'search-bar-1'}
                                            value={value || ''}
                                            className={
                                                (props.showTooltip ? 'holder' : '') +
                                                ' height-36 form-control form-control-icon dash-filter-picker'
                                            }
                                            placeholder={`Search ${props.searchPlaceHolder ? 'by ' + props.searchPlaceHolder : ''}`}
                                            onChange={(e: any) => {
                                                excludeSpecialCharInSearch(e);
                                            }}
                                        />
                                        {props.showTooltip &&
                                            Tooltip(
                                                props.changeID ? 'search-bar-1-' + props.tabName : 'search-bar-1',
                                                value && value !== '' ? value : `Search${props.searchPlaceHolder}`
                                            )}
                                        <i className="ri-search-line link-info"></i>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}
                    {props.dateRangeFilter && (
                        <Col sm="auto">
                            <Row className="align-items-center">
                                <div className="col-sm-auto">
                                    <div className="form-icon flex-nowrap">
                                        <Flatpickr
                                            ref={fp}
                                            value={dateVal}
                                            placeholder={`Search${props.datePlaceHolder}`}
                                            className={
                                                (props.showTooltip ? 'holder' : '') +
                                                (props.dateClass ? ' ' + props.dateClass : '') +
                                                ' form-control form-control-icon w-100 date-filter-picker'
                                            }
                                            options={{ mode: 'range', dateFormat: 'd M, Y' }}
                                            onChange={(e: any) => {
                                                setDateVal(e);
                                                setActivePage(1);
                                                onChangePicker(e);
                                            }}
                                        />
                                        <i className="ri-calendar-2-line" />
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}
                    {/* cards icon */}
                    {props.cardIcon && (
                        <Col sm="auto">
                            <Row className="align-items-center cursor-pointer">
                                {/* <div className="col-sm-auto">
									<i
										className={`ri-table-fill fs-18 cursor-pointer link-${props.isShowTable ? '' : 'success'}`}
										onClick={() => props?.handleCardIcon()}
									/>
								</div> */}
                                <div className="col-sm-auto" onClick={() => props?.handleCardIcon()}>
                                    <div
                                        className={`avatar-title img-thumbnail text-uppercase border fs-3 bg-soft-${
                                            props?.isIcon === 'card' ? 'active' : 'light'
                                        }`}
                                    >
                                        <i
                                            className={`ri-grid-line fs-20 px-1 ${props?.isIcon === 'card' ? 'text-white' : 'text-dark'}`}
                                        ></i>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}
                    {/* table icon */}
                    {props.tableIcon && (
                        <Col sm="auto">
                            <Row className="align-items-center cursor-pointer">
                                <div className="col-xs-auto" onClick={() => props?.handleTableIcon()}>
                                    <div
                                        className={`avatar-title img-thumbnail text-uppercase border bg-soft-${
                                            props?.isIcon === 'table' ? 'active' : 'light'
                                        }`}
                                    >
                                        <i
                                            className={`ri-menu-2-fill fs-18 px-1 ${
                                                props?.isIcon === 'table' ? 'text-white' : 'text-dark'
                                            }`}
                                        ></i>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}
                    {/* map icon */}
                    {props.mapIcon && (
                        <Col sm="auto">
                            {/* <Row className="align-items-center cursor-pointer">
								<div className="col-sm-auto">
									<i
										className={`ri-road-map-line  fs-18 cursor-pointer link-${props.isShowTable ? 'success' : ''}`}
										onClick={() => props?.handleMapIcon()}
									/>
								</div>
							</Row> */}

                            <Row className="align-items-center cursor-pointer">
                                <div className="col-xs-auto" onClick={() => props?.handleMapIcon()}>
                                    <div
                                        className={`avatar-title img-thumbnail text-upparcase border bg-soft-${
                                            props?.isIcon === 'map' ? 'active' : 'light'
                                        }`}
                                    >
                                        <i
                                            className={`ri-road-map-line  fs-18 px-1 ${
                                                props?.isIcon === 'map' ? 'text-white' : 'text-dark'
                                            }`}
                                        />
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    )}
                    {props.pairButton && (
                        /*
                         * <IsAuthorized
                         *     privRequired={props.type === 'adminAccess' ? props.adminAccess : editor}
                         *     yes={() => (
                         */
                        <Col sm="auto" className="d-flex justify-content-end p-0 ms-2">
                            <div>
                                <Button outline type="button" color="primary" onClick={() => props.handleAddPair()}>
                                    <span>
                                        <i className="bx bx-duplicate"></i>
                                        {/* <img src={PairBatteriesIcon} alt="pair-battery" /> */}
                                    </span>
                                    <span> {props.pairButtonText ? props.pairButtonText : 'Pair Batteries'}</span>
                                </Button>
                            </div>
                        </Col>
                        /*
                         *     )}
                         *      />
                         */
                    )}
                    {props.columnChooser && (
                        /*
                         * <IsAuthorized
                         *     privRequired={props.type === 'adminAccess' ? props.adminAccess : editor}
                         *     yes={() => (
                         */
                        <Col sm="auto" className="d-flex justify-content-end align-items-center p-0 ms-2 cursor-pointer">
                            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle tag={'div'}>
                                    {' '}
                                    <img src={columnChooser} alt="column-chooser" />
                                    {/* onClick={() => props.handleColumns()} */}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {selectedColumns.map((column: any) => {
                                        return (
                                            column.isEditable && (
                                                <>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <input
                                                            id={'index-' + column.key}
                                                            className="form-check-input fs-16 ms-2 mt-0"
                                                            type="checkbox"
                                                            checked={column.isActive}
                                                            onChange={(e: any) => columnChooserClick(column)}
                                                        />
                                                        <label htmlFor={'index-' + column.key} className="ms-2 mb-0 fs-16 fw-200">
                                                            {column.label}
                                                        </label>
                                                    </div>
                                                </>
                                            )
                                        );
                                    })}
                                    {/* <DropdownItem header>Header</DropdownItem>
                                    <DropdownItem>Some Action</DropdownItem>
                                    <DropdownItem text>Dropdown Item Text</DropdownItem>
                                    <DropdownItem disabled>Action (disabled)</DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem>Foo Action</DropdownItem>
                                    <DropdownItem>Bar Action</DropdownItem>
                                    <DropdownItem>Quo Action</DropdownItem> */}
                                    <div className="d-flex gap-2 ms-2 me-2">
                                        <Button
                                            type="button"
                                            color="primary"
                                            onClick={() => toggle()}
                                            // disabled={props?.disabledbtn}
                                            className="height-30 d-flex align-items-center justify-content-center"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="button"
                                            color="info"
                                            onClick={() => {
                                                props.handleColumns(selectedColumns);
                                                toggle();
                                            }}
                                            // disabled={props?.disabledbtn}
                                            className="height-30 d-flex align-items-center justify-content-center"
                                        >
                                            Update
                                        </Button>
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                        /*
                         *     )}
                         *      />
                         */
                    )}
                    {props.rightDropDownFilter && (
                        <Col sm="auto">
                            <div className={`d-flex ${props.largeSearchFilter ? 'width-470' : ''}`}>
                                <div className="d-flex justify-content-end p-0 ms-2 px-2 fw-normal">
                                    <h5>{props.dropDownFilterLabel} </h5>
                                </div>
                                <Select
                                    getOptionValue={(option: { value: any }) => option.value}
                                    getOptionLabel={(option: { label: any }) => option.label}
                                    isMulti={props?.dropDownParams?.isMulti ? true : false}
                                    isClearable={props?.dropDownParams?.isMulti || props?.dropDownParams?.clearable ? true : false}
                                    id={props?.dropDownParams?.label}
                                    name={props?.dropDownParams?.value}
                                    options={props?.dropDownParams?.options}
                                    placeholder={`Select ${props?.dropDownParams?.label}`}
                                    onChange={(e: React.SetStateAction<undefined>) => {
                                        setDropDownValue(e);
                                        setActivePage(1);
                                        handleSelectChange(e);
                                    }}
                                    value={dropDownValue || ''}
                                    isSearchable={true}
                                    className={`dropdown-filter-picker ${props.largeSearchFilter ? 'w-100' : ''}`}
                                    classNamePrefix={'custom-select'}
                                    noOptionsMessage={() => 'No data found'}
                                />
                            </div>
                        </Col>
                    )}
                    {props.addButton && (
                        <IsAuthorized
                            privRequired={props?.priv?.add}
                            yes={() => (
                                <Col sm="auto" className="d-flex justify-content-end p-0 ms-2">
                                    <div>
                                        <Button
                                            type="button"
                                            color="primary"
                                            onClick={() => props.handleAddNew()}
                                            disabled={props?.disabledbtn}
                                        >
                                            + {props.addButtonText ? props.addButtonText : 'Add New'}
                                        </Button>
                                    </div>
                                </Col>
                            )}
                        />
                    )}

                    {props.clearFiltersButton && (
                        <Col className="d-flex justify-content-end">
                            <Button
                                className="w-100"
                                type="button"
                                color="primary"
                                outline={true}
                                onClick={() => {
                                    props.handleClearFilters && props.handleClearFilters();
                                    setDateVal('');
                                    setValue('');
                                    setActivePage(1);
                                    setDropDownValue(null);
                                }}
                            >
                                Clear Filters
                            </Button>
                        </Col>
                    )}
                    {/* tableHeader at the end in table */}
                    {
                        <Col sm="auto">
                            <div className="d-flex">
                                {tableHeaderEnd &&
                                    (props.tableHeaderEndBody ? (
                                        props.tableHeaderEndBody
                                    ) : (
                                        <div className="d-flex justify-content-center align-items-center">
                                            {props.headerImage && <img src={props.headerImage} alt="" />}
                                            <h4
                                                className={`card-title mt-2 ${props.headerImage ? 'ps-2' : ''} ${
                                                    props.tableLabelClass || ''
                                                }`}
                                            >
                                                {tableHeaderEnd}
                                                {!props.hideDisplayTotalCount && ` (${props?.totalAmount ?? 0})`}
                                            </h4>
                                        </div>
                                    ))}
                            </div>
                        </Col>
                    }

                    {props.actionsDownload && (
                        <Col sm="auto">
                            <div className="d-flex">
                                <Button
                                    type="button"
                                    color="primary"
                                    // outline
                                    id="actionsDownload"
                                    className="ps-2 pe-2 pt-1 pb-1"
                                    onClick={() => props.handleDownload('actions')}
                                    disabled={props?.disabled}
                                >
                                    <span className="d-flex align-items-center  gap-2">
                                        <i className="ri-file-download-line align-bottom fs-18"></i>
                                        <p className=" fs-12 m-0">{props.downloadText}</p>
                                    </span>
                                </Button>
                            </div>
                        </Col>
                    )}
                    {props.actionsUpload && (
                        <IsAuthorized
                            privRequired={editor}
                            yes={() => (
                                <Col sm="auto">
                                    <div className="d-flex">
                                        <Button
                                            type="button"
                                            color="primary"
                                            // outline
                                            className="ps-2 pe-2 pt-1 pb-1"
                                            id="bulkupload"
                                            onClick={uploadDoc}
                                        >
                                            <span className="d-flex align-items-center fs-18 gap-2">
                                                <i className="ri-file-download-line align-button" id="bulkupload"></i>
                                                <p className=" fs-12 m-0">{props.uploadText}</p>
                                            </span>
                                        </Button>
                                        {Tooltip('bulkupload', 'Bulk Import Actions')}
                                        <input
                                            hidden
                                            id="file"
                                            type="file"
                                            accept={props.acceptFiles}
                                            ref={(file) => setFileUploader(file)}
                                            onChange={(ev) => handleUpload(ev, 'actions')}
                                            onClick={(ev: any) => (ev.target.value = null)}
                                        />
                                    </div>
                                </Col>
                            )}
                        />
                    )}

                    {props.upload && (
                        <IsAuthorized
                            privRequired={editor}
                            yes={() => (
                                <Col sm="auto">
                                    <div className="d-flex">
                                        <Button
                                            type="button"
                                            color="primary"
                                            outline={props.uploadParams.outlined}
                                            id="upload"
                                            onClick={props.uploadParams.handleUpload}
                                        >
                                            <span className="d-flex align-items-center gap-2">
                                                <i
                                                    className={`${
                                                        props.uploadParams.icon ? props.uploadParams.icon : 'ri-upload-2-line'
                                                    } align-bottom`}
                                                    id="upload"
                                                ></i>
                                                <p className=" fs-12 m-0">{props.uploadText}</p>
                                                <span>{props.uploadParams.label}</span>
                                            </span>
                                        </Button>
                                        {props.uploadParams.uploadTooltip && <>{Tooltip('upload', props.uploadParams.uploadTooltip)}</>}
                                    </div>
                                </Col>
                            )}
                        />
                    )}

                    {props.download && (
                        <IsAuthorized
                            privRequired={editor}
                            yes={() => (
                                <Col sm="auto">
                                    <div className="d-flex">
                                        <Button
                                            type="button"
                                            color="primary"
                                            outline={props.downloadParams?.outlined}
                                            id="download"
                                            disabled={props.downloadParams?.loading}
                                            onClick={props.downloadParams?.handleDownload}
                                        >
                                            {props.downloadParams?.loading ? (
                                                <span className="d-flex align-items-center">
                                                    <span className="flex-grow-1 ms-2">Loading...</span>
                                                </span>
                                            ) : (
                                                <span className="d-flex align-items-center ">
                                                    <i
                                                        className={`${
                                                            props.downloadParams?.icon ? props.downloadParams?.icon : 'ri-download-2-line'
                                                        } align-bottom`}
                                                        id="download"
                                                    ></i>{' '}
                                                    <span>{props.downloadParams?.label}</span>
                                                </span>
                                            )}
                                        </Button>
                                        {props.downloadParams?.uploadTooltip && (
                                            <>{Tooltip('download', props.downloadParams?.uploadTooltip)}</>
                                        )}
                                    </div>
                                </Col>
                            )}
                        />
                    )}
                </Row>
            </Col>
        );
    };

    return (
        <Fragment>
            <Card
                className={`${props.tableCardClass ? props.tableCardClass : ''} ${
                    props.noCardHeight ? 'p-0' : 'card-height-100 p-0 m-0'
                } box-shadow-none p-0 px-3 py-1  ${props.boxshadow ? props.boxshadow : ''}`}
                style={{ boxShadow: 'none' }}
            >
                {isGlobalFilter && (
                    <CardHeader className={props.hideHeaderPadding ? 'px-0 pt-0' : 'p-0 pt-3 pb-3'}>{TopFilterPanel()}</CardHeader>
                )}
                <CardBody className={`${props.loading ? 'p-0 pe-4' : ''}`}>
                    {props.loading ? (
                        <TableSkelton />
                    ) : (
                        <React.Fragment>
                            {!props?.isShowTable ? (
                                <div className={divClass}>
                                    <Table hover={data?.length > 0} {...getTableProps()} className={tableClass + ' overflow-x-hidden'}>
                                        <thead className={theadClass}>
                                            {headerGroups.map(
                                                (headerGroup: {
                                                    id: React.Key | null | undefined;
                                                    getHeaderGroupProps: () => JSX.IntrinsicAttributes &
                                                        React.ClassAttributes<HTMLTableRowElement> &
                                                        React.HTMLAttributes<HTMLTableRowElement>;
                                                    headers: any[];
                                                }) => {
                                                    return (
                                                        <tr className={trClass} {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                            {headerGroup.headers.map(
                                                                (
                                                                    column:
                                                                        | {
                                                                              customHeader: any;
                                                                              id: React.Key | null | undefined;
                                                                              thClass: any;
                                                                              sortable: any;
                                                                              getSortByToggleProps: () => JSX.IntrinsicAttributes &
                                                                                  React.ClassAttributes<HTMLTableHeaderCellElement> &
                                                                                  React.ThHTMLAttributes<HTMLTableHeaderCellElement>;
                                                                              render: (
                                                                                  arg0: string
                                                                              ) =>
                                                                                  | string
                                                                                  | number
                                                                                  | boolean
                                                                                  | React.ReactElement<
                                                                                        any,
                                                                                        string | React.JSXElementConstructor<any>
                                                                                    >
                                                                                  | Iterable<React.ReactNode>
                                                                                  | null
                                                                                  | undefined;
                                                                          }
                                                                        | any
                                                                ) =>
                                                                    column.customHeader ? (
                                                                        <th
                                                                            key={column.id}
                                                                            className={
                                                                                (thClass ? thClass : '') +
                                                                                ' ' +
                                                                                (column.thClass ? column.thClass : '') +
                                                                                'text-black'
                                                                            }
                                                                        >
                                                                            {prepareCustomHeader(column)}
                                                                        </th>
                                                                    ) : column.sortable ? (
                                                                        <th
                                                                            key={column.id}
                                                                            className={
                                                                                (thClass ? thClass : '') +
                                                                                ' ' +
                                                                                (column?.thClass ? column?.thClass : '') +
                                                                                'text-black'
                                                                            }
                                                                            {...column.getSortByToggleProps()}
                                                                        >
                                                                            {column.render('Header')}
                                                                            {generateSortingIndicator(column)}
                                                                            {/* <Filter column={column} /> */}
                                                                        </th>
                                                                    ) : (
                                                                        <th
                                                                            key={column.id}
                                                                            className={
                                                                                (thClass ? thClass : '') +
                                                                                ' ' +
                                                                                (column?.thClass ? column?.thClass : '') +
                                                                                'text-black'
                                                                            }
                                                                            // {...column.getSortByToggleProps()}
                                                                        >
                                                                            {column.render('Header')}
                                                                            {/* {generateSortingIndicator(column)} */}
                                                                            {/* <Filter column={column} /> */}
                                                                        </th>
                                                                    )
                                                            )}
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </thead>

                                        <tbody {...getTableBodyProps()}>
                                            {page?.length > 0 ? (
                                                page.map(
                                                    (
                                                        row: {
                                                            getRowProps: () => { (): any; new (): any; key: React.Key | null | undefined };
                                                            original: { bgClassGroup: string | undefined };
                                                            cells: any[];
                                                        },
                                                        index: any
                                                    ) => {
                                                        prepareRow(row);
                                                        return (
                                                            <Fragment key={row.getRowProps().key}>
                                                                <tr className={row.original.bgClassGroup ? row.original.bgClassGroup : ''}>
                                                                    {row.cells.map((cell: any) => {
                                                                        return (
                                                                            <td
                                                                                className={
                                                                                    cell.column.className ? cell.column.className : ''
                                                                                }
                                                                                key={cell.id}
                                                                                {...cell.getCellProps({
                                                                                    style: {
                                                                                        width: cell.column.width,
                                                                                        maxWidth: cell.column.maxWidth,
                                                                                        minWidth: cell.column.minWidth
                                                                                    }
                                                                                })}
                                                                            >
                                                                                {cell.column.customCell ? (
                                                                                    prepareCustomBody(cell, row, index)
                                                                                ) : (
                                                                                    <EllipsisToolTip
                                                                                        options={{ effect: 'solid', place: 'bottom' }}
                                                                                    >
                                                                                        {cell.value === 0
                                                                                            ? cell.value
                                                                                            : cell.value && cell.value !== ''
                                                                                            ? cell.render('Cell')
                                                                                            : cell.column.id !== 'sample' &&
                                                                                              cell.column.id !== 'html' &&
                                                                                              '—'}
                                                                                    </EllipsisToolTip>
                                                                                )}
                                                                                {/* {colors(cell)} */}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            </Fragment>
                                                        );
                                                    }
                                                )
                                            ) : (
                                                <tr>
                                                    <td className="fs-14" colSpan={columns?.length}>
                                                        {emptyMessage ? emptyMessage : 'No Records Found.'}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            ) : (
                                <>{props?.additionalTableComponent && props?.additionalTableComponent()}</>
                            )}
                        </React.Fragment>
                    )}
                </CardBody>
                {!props.hidePagination && (
                    <>
                        {(totalRecords !== undefined && !value ? totalRecords > 10 : globalFilteredRows?.length > 5) && (
                            <Pagination
                                data={data}
                                length={totalRecords ? totalRecords : globalFilteredRows?.length}
                                itemsPerPage={customPageSize ? customPageSize : pageSize}
                                onPageChange={handlePageChange}
                                activePage={onPageChange ? (pageNum ? pageNum : activePage) : pageIndex + 1}
                                pageRangeDisplayed={3}
                            />
                        )}
                    </>
                )}
            </Card>
        </Fragment>
    );
};

export default TableContainer;
